PJQ.collections.bidForms = {};

PJQ.models.bidForms = {};

PJQ.views.bidForms = {};

function initBidFormsAdmin() {
	if (!PJQ.app.BidFormEditor) {
		let initProposalId = PJQ.helpers.urlHelpers.getQueryParam('proposal');
		if (_.size(initProposalId) > 0) {
			initProposalId = parseInt(initProposalId);
		}
		PJQ.app.BidFormEditor = new PJQ.views.bidForms.BidFormEditorSelector({
			el: '#project-bidforms',
			project: PJQ.app.session.project,
			collection: new PJQ.collections.bidForms.GroupBidForms([]),
			initProposalId: initProposalId
		});
	}
}

function initBidFormsSub() {
	new PJQ.views.bidForms.BidFormViewerSelectorModal({
		model: new PJQ.models.bidForms.Bidder({
			contactId: PJQ.app.session.contact.id
		})
	});
}

PJQ.modules.bidForms = {
	routes: [
		{
			route: 'projects/:projectId/bidforms',
			name: 'projectBidForms',
			callback: function (projectId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "bidforms");
			}
		},
		{
			route: 'projects/:projectId/bidforms/:groupId',
			name: 'projectProposal',
			callback: function (projectId, groupId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "bidforms", {
					groupId: parseInt(groupId)
				});
			}
		},
		{
			route: 'projects/:projectId/proposals/:proposalId',
			name: 'projectProposal',
			callback: function (projectId, proposalId) {
				PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "bidforms", {
					proposalId: parseInt(proposalId)
				});
			}
		}
	]
};

PJQ.app.addRoutes(PJQ.modules.bidForms.routes);
//Models
PJQ.models.bidForms.Bidder = PJQ.models.BaseModel.extend({
    idAttribute: "contactCompanyId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
	            value: PJQ.app.session.project.id
            },
            {
                endpoint: 'contacts',
                value: !this.id && this.get('contactId') ? this.get('contactId') : this.id
            },
            {
                endpoint: 'proposals'
            }
        ])
    },
	parse: function (model) {
        if (model.proposals) {
            if (this.proposals)
                this.proposals.reset(model.proposals);
            else
                this.proposals = new PJQ.collections.bidForms.Proposals(model.proposals);

            _.each(this.proposals.models, function (proposal) {
                proposal.bidder = this;
            }, this);
        }
        else {
            this.proposals = new PJQ.collections.bidForms.Proposals();
        }

        if (model.contacts) {
            if (this.contacts)
                this.contacts.reset(model.contacts);
            else
                this.contacts = new PJQ.collections.bidForms.BidderContacts(model.contacts);
        }
        else {
            this.contacts = new PJQ.collections.bidForms.BidderContacts();
        }
        return model;
    },
    getProposal: function (bidFormId) {
        return this.proposals.findWhere({bidFormId: bidFormId})
    }
});

PJQ.models.bidForms.BidderContact = PJQ.models.projectParticipants.ProjectParticipant.extend({
    idAttribute: "contactId",
    getStatusColor: function () {
        switch (this.get('bidStatus').toLowerCase()) {
            case 'accept':
                return '#4CAF50';
            case 'decline':
                return '#dc3545';
            case 'bid received':
                return '#2196F3';
            case 'awarded':
                return '#4CAF50';
            case 'pending':
            default:
	            return '#9E9E9E';
        }
    },
    getProposal: function (bidFormId) {
        return this.proposals.findWhere({bidFormId: bidFormId})
    }
});


//Collections
PJQ.collections.bidForms.Bidders = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.Bidder,
    getProposals: function (bidFormId) {
	    let proposals = new PJQ.collections.bidForms.Proposals([], {bidFormId: bidFormId});
        _.each(this.models, function (model) {
            _.each(model.proposals.models, function (proposal) {
                if (bidFormId == null || proposal.get('bidFormId') === bidFormId)
                    proposals.add(proposal);
            });
        });
        return proposals;
    },
    getProposalCount: function (bidFormId) {
        let proposalCount = 0;
        _.each(this.models, function (model) {
            proposalCount += model.get('proposalCount');
        });
        return proposalCount;
    },
	removeProposal: function (proposal) {
		_.each(this.models, function (model) {
			let matchProposal = model.proposals.get(proposal.id);
			if(matchProposal != null){
				model.proposals.remove(proposal);
			}
		});
	},
    getLowestProposal: function (bidFormId, isIncludeAlternates) {
        return this.getProposals(bidFormId).getLowestProposal(isIncludeAlternates);
    }
});

PJQ.collections.bidForms.BidderContacts = PJQ.collections.contacts.Contacts.extend({
    model: PJQ.models.bidForms.BidderContact
});
PJQ.views.bidForms.Bidders = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bidders-Container'),
		subTemplates: {
			bidder: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bidder')
		},
		numPerPage: 5
	},
	events: {
		'click .bidder-review-proposal': 'reviewProposal',
		'click .bidder-create-proposal': 'createProposal',
		'keyup .bidders-search': 'filterBidders',
		'click .bidders-clear-filters': 'clearFilters',
		'click .bidder-edit': 'editBidder',
		'click .bidder-delete': 'deleteBidder'
	},
	beforeFirstRender: function () {
		this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
		this.listenTo(this.collection, "sync reset change", this.render);
	},
	renderData: function () {
		let searchFilter = this.getSearchFilter().toLowerCase(),
			renderModels = this.collection.models,
			statusFilter = this.getStatusFilter();
		if (_.size(searchFilter) > 0) {
			renderModels = _.filter(renderModels, function (model) {
				return null != _.find(model.contacts.models, function (contact) {
					if (contact.get('email').toLowerCase().indexOf(searchFilter) !== -1)
						return true;
					else if (contact.get('companyName').toLowerCase().indexOf(searchFilter) !== -1)
						return true;
					else if (contact.get('contactName').toLowerCase().indexOf(searchFilter) !== -1)
						return true;
					else {
						let numSearch = PJQ.helpers.formatHelpers.numbersOnly(searchFilter);
						if (_.size(numSearch) === 0)
							return false;
						if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('phone')).indexOf(numSearch) !== -1)
							return true;
						else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('fax')).indexOf(numSearch) !== -1)
							return true;
						else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('cell')).indexOf(numSearch) !== -1)
							return true;
					}
				});
			});
		}

		if (_.size(statusFilter) > 0) {
			renderModels = _.filter(renderModels, function (bidder) {
				return _.find(bidder.contacts.models, function (model) {
					return statusFilter.indexOf(model.get('bidStatus').toLowerCase()) !== -1;
				});
			}, this);
		}

		return {
			models: _.sortBy(renderModels, function (model) {
				return model.get('companyName');
			}),
			project: this.options.project,
			canEdit: this.options.canEdit,
			bidFormId: this.options.bidFormId,
			helpers: PJQ.helpers,
			colClass: this.options.colClass
		};
	},
	afterRender: function () {
		this.statusFilterPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.bidders-status-filter'),
			onChange: _.bind(this.filterBidders, this),
			isMultiple: true,
			noneSelectedText: 'No Filters'
		});
		this.searchBar = this.$('.bidders-search');

		this.renderBidders();
	},
	renderBidders: function () {
		let renderData = this.renderData(),
			pageContainer = this.$('.bidders-data');
		if (renderData.models.length > 0) {
			this.$('.bidders-pagination').pagination({
				dataSource: renderData.models,
				pageSize: 5,
				callback: _.bind(function (data) {
					pageContainer.empty();
					_.each(data, function (bidder) {
						this.renderSubTemplate(true, this.options.subTemplates.bidder, pageContainer, {
							project: this.options.project,
							canEdit: this.options.canEdit,
							canViewProposal: this.options.project != null ? (this.options.settings.isSealedBidContact(PJQ.app.session.user.get('id')) || !this.options.settings.get('isSealBids')) : true,
							canCreateProposal: this.options.project != null ? !this.options.settings.get('isSealBids') : true,
							bidder: bidder,
							bidFormId: renderData.bidFormId
						});
					}, this);
				}, this)
			});
		}
		else {
			new PJQ.Alert(pageContainer, {
				text: "No participants match the search criteria"
			})
		}
	},
	clearFilters: function () {
		this.statusFilterPicker.deselectAll();
		this.searchBar.val('');
		this.filterBidders();
	},
	filterBidders: function () {
		this.statusFilter = this.statusFilterPicker.getValue();
		this.search = this.searchBar.val().trim();
		this.renderBidders();
	},
	getStatusFilter: function () {
		return this.statusFilter ? this.statusFilter : [];
	},
	getSearchFilter: function () {
		return this.search ? this.search : "";
	},
	reviewProposal: function (e) {
		let cid = $(e.currentTarget).closest('.bidder-row').data('cid'),
			proposal = this.collection.get(cid).getProposal(this.options.bidFormId);

		if (proposal) {
			proposal.preview(this.collection, {
				isEdit: false
			});
		}
	},
	createProposal: function (e) {
		let cid = $(e.currentTarget).closest('.bidder-row').data('cid'),
			bidder = this.collection.get(cid);

		let newProposal = new PJQ.models.bidForms.Proposal({
			contactCompanyId: bidder.get('contactCompanyId'),
			groupId: bidder.get('groupId'),
			bidPackageId: bidder.get('bidPackageId'),
			projectId: this.options.project.id,
			bidFormId: bidder.collection.options.bidFormId
		}, {parse: true});
		newProposal.bidder = bidder;
		newProposal.preview(this.collection, {
			isEdit: true
		});
		newProposal.save();
		bidder.proposals.add(newProposal);
		this.collection.trigger('change');
	},
	editBidder: function (e) {
		let cidCompany = $(e.currentTarget).closest('.bidder-row').data('cid'),
			cidContact = $(e.currentTarget).closest('.bidder-contact-container').data('cid'),
			company = this.collection.get(cidCompany),
			contact = company.contacts.get(cidContact);

		new PJQ.views.contacts.BaseEditContactModal({
			model: contact,
			onSave: _.bind(function () {
				company.set('companyName', contact.get('companyName'));
				this.renderBidders();
			}, this)
		});
	},
	deleteBidder: function (e) {
		let cidCompany = $(e.currentTarget).closest('.bidder-row').data('cid'),
			cidContact = $(e.currentTarget).closest('.bidder-contact-container').data('cid'),
			company = this.collection.get(cidCompany),
			contact = company.contacts.get(cidContact);

		new PJQ.views.modals.DeleteCancel({
			header: "Delete Participant",
			body: "Are you sure you want to remove this bid participant from the project?",
			onDelete: _.bind(function () {
				contact.destroy();
				if (_.size(company.contacts) <= 1) {
					this.collection.remove(company);
				}
				this.renderBidders();
			}, this)
		});
	}
});
//Models
PJQ.models.bidForms.Template = PJQ.models.BaseModel.extend({
	idAttribute: "templateId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'templates',
				value: this.id
			}
		], [
			{
				parameter: 'projectId',
				value: this.get('projectId')
			},
			{
				parameter: 'groupIds',
				value: this.get('groupIds')
			}
		])
	},
	parse: function (template) {
		this.groupBidForms = new PJQ.collections.bidForms.GroupBidForms({
			groupBidForms: template ? template.groupBidForms : [],
			projectBidForm: template ? template.projectBidForm : null
		});
		return template;
	}
});

PJQ.models.bidForms.BidFormSummary = PJQ.models.BaseModel.extend({
	idAttribute: "bidFormId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.id
			}
		])
	},
	parse: function (bidForm) {
		if (bidForm.managedBy != null) {
			this.managedBy = new PJQ.models.contacts.Contact(bidForm.managedBy);
		}
		else {
			this.managedBy = null;
		}
		return bidForm;
	}
});

PJQ.models.bidForms.ProjectBidForm = PJQ.models.BaseModel.extend({
	idAttribute: "bidFormId",
	endpoint: function () {
		if (this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'bidforms',
					value: this.id
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.id
			}
		]);
	},
	beforeConstruct: function (attributes) {
		this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
		this.bonding = new PJQ.collections.bidForms.Bonding([], {bidFormId: attributes.bidFormId});
		this.certifications = new PJQ.collections.bidForms.Certifications([], {bidFormId: attributes.bidFormId});
		this.laborRates = new PJQ.collections.bidForms.LaborRates([], {bidFormId: attributes.bidFormId});
	},
	parse: function (bidForm) {
		if (bidForm.acknowledgements) {
			this.acknowledgements.reset(bidForm.acknowledgements);
		}
		if (bidForm.bonding) {
			this.bonding.reset(bidForm.bonding);
		}

		if (bidForm.certifications) {
			this.certifications.reset(bidForm.certifications);
		}

		if (bidForm.laborRates) {
			this.laborRates.reset(bidForm.laborRates);
		}

		return bidForm;
	},
	updateAcknowledgementDeleted: function (cid, isDeleted) {
		let acknowledgement = this.acknowledgements.get({cid: cid});
		if (acknowledgement.id == null)
			this.acknowledgements.remove(acknowledgement);
		else
			acknowledgement.set('isDeleted', isDeleted);
	},
	updateBondingDeleted: function (cid, isDeleted) {
		let bonding = this.bonding.get({cid: cid});
		if (bonding.id == null)
			this.bonding.remove(bonding);
		else
			bonding.set('isDeleted', isDeleted);
	},
	updateCertificationDeleted: function (cid, isDeleted) {
		let certification = this.certifications.get({cid: cid});
		if (certification.id == null)
			this.certifications.remove(certification);
		else
			certification.set('isDeleted', isDeleted);
	},
	updateLaborRateDeleted: function (cid, isDeleted) {
		let laborRate = this.laborRates.get({cid: cid});
		if (laborRate.id == null)
			this.laborRates.remove(laborRate);
		else
			laborRate.set('isDeleted', isDeleted);
	},
	beforeSave: function () {
		this.set('acknowledgements', this.acknowledgements.getChangedModels());
		this.set('bonding', this.bonding.getChangedModels());
		this.set('certifications', this.certifications.getChangedModels());
		this.set('laborRates', this.laborRates.getChangedModels());
	}
});

PJQ.models.bidForms.GroupBidForm = PJQ.models.bidForms.ProjectBidForm.extend({
	beforeConstruct: function (attributes) {
		if (attributes.bidPackage != null) {
			this.bidPackage = new PJQ.models.bidPackages.BidPackage(attributes.bidPackage);
		}
		else {
			this.bidPackage = null;
		}

		this.lineItems = new PJQ.collections.bidForms.LineItems([], {bidFormId: attributes.bidFormId});
		this.alternates = new PJQ.collections.bidForms.Alternates([], {bidFormId: attributes.bidFormId});
		this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
		this.bidders = new PJQ.collections.bidForms.Bidders([], {bidFormId: attributes.bidFormId});

		if (attributes.managedBy != null) {
			this.managedBy = new PJQ.models.contacts.Contact(attributes.managedBy);
		}
		else {
			this.managedBy = null;
		}
	},
	parse: function (bidForm) {
		if (bidForm.lineItems) {
			this.lineItems.reset(bidForm.lineItems);
		}

		if (bidForm.alternates) {
			this.alternates.reset(bidForm.alternates);
		}

		if (bidForm.acknowledgements) {
			this.acknowledgements.reset(bidForm.acknowledgements);
		}

		if(bidForm.bidPackageId > 0 && bidForm.bidPackage){
			this.bidPackage = new PJQ.models.bidPackages.BidPackage(bidForm.bidPackage)
		}

		if (bidForm.bidders) {
			this.bidders.reset(bidForm.bidders);

			if (bidForm.managedBy != null) {
				this.managedBy = new PJQ.models.contacts.Contact(bidForm.managedBy);
			}
			else {
				this.managedBy = null;
			}
		}

		return bidForm;
	},
	getDueDate: function () {
		let dueDate = this.get('dueDate');
		return dueDate == null ? null : new Date(dueDate);
	},
	preview: function (collection, opts) {
		if (!opts)
			opts = {};
		opts.model = this;
		opts.collection = collection;
		if (this.projectBidForm) {
			opts.projectBidForm = this.projectBidForm;
		}
		new PJQ.views.bidForms.BidFormPreviewModal(opts);
	},
	updateLineItemDeleted: function (cid, isDeleted) {
		let lineItem = this.lineItems.get({cid: cid});
		if (lineItem.id == null)
			this.lineItems.remove(lineItem);
		else
			lineItem.set('isDeleted', isDeleted);
	},
	updateAlternateDeleted: function (cid, isDeleted) {
		let alternate = this.alternates.get({cid: cid});
		if (alternate.id == null)
			this.alternates.remove(alternate);
		else
			alternate.set('isDeleted', isDeleted);
	},
	calculateTotal: function (isIncludeAlternates = false, forceSubmitted) {
		let lineItems = this.lineItems.models,
			total = 0;
		for (let i = 0; i < lineItems.length; i++) {
			total += lineItems[i].calculateTotal(forceSubmitted);
		}

		if (isIncludeAlternates) {
			let alternates = this.alternates.models;
			for (let i = 0; i < alternates.length; i++) {
				if (alternates[i].get('isLevel')) {
					total += alternates[i].calculateTotal(forceSubmitted);
				}
			}
		}
		return total;
	},
	beforeSave: function () {
		this.set('lineItems', this.lineItems.getChangedModels());
		this.set('alternates', this.alternates.getChangedModels());
		this.set('acknowledgements', this.acknowledgements.getChangedModels());
		this.set('managedBy', this.managedBy);

		if (!this.bidPackage)
			this.set('dueDate', null);
	}
});

PJQ.models.bidForms.LineItem = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'lineitems',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.lineItemTypes[0].name,
		isRequired: false,
		cost: 0,
		multiplier: 0
	},
	calculateTotal: function (forceSubmitted) {
		let cost = this.get('leveledCost') && forceSubmitted !== false ? this.get('leveledCost') : this.get('cost'),
			multiplier = this.get('leveledMultiplier') && forceSubmitted !== false ? this.get('leveledMultiplier') : this.get('multiplier');
		switch (this.get('type').toLowerCase()) {
			case "sum":
				return cost == null ? 0 : cost;
			default:
				return (cost == null ? 0 : cost) * (multiplier == null ? 0 : multiplier);
		}
	}
});

PJQ.models.bidForms.Alternate = PJQ.models.bidForms.LineItem.extend({
	idAttribute: 'id',
	beforeConstruct: function (attributes) {
		this.choices = new PJQ.collections.customFields.CustomFieldChoices(attributes.choices);
	},
	parse: function (alternate) {
		this.choices.reset(alternate.choices);
		return alternate;
	},
	getCustomFieldType: function () {
		let result = {
			type: '',
			isMultipleChoice: false
		}
		switch (this.get('type').toLowerCase()) {
			case 'money':
			case 'date':
			case 'text':
			case 'textarea':
				result.type = this.get('type').toUpperCase();
				break;
			case 'single choice':
			case 'multiple choice':
				result.isMultipleChoice = true;
				result.type = PJQ.constants.customFields.fieldTypes.CHOICE;
				break;
			case 'numeric':
				result.type = PJQ.constants.customFields.fieldTypes.INT;
				break;
			case 'yes/no':
				result.type = PJQ.constants.customFields.fieldTypes.BOOL;
				break;
		}
		return result;
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'alternates',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.alternateTypes[0].name,
		isRequired: false,
		cost: 0,
		multiplier: 0
	}
});

PJQ.models.bidForms.Acknowledgement = PJQ.models.BaseModel.extend({
	idAttribute: 'id',
	beforeConstruct: function (attributes) {
		this.choices = new PJQ.collections.customFields.CustomFieldChoices(attributes.choices);
	},
	parse: function (acknowledgement) {
		this.choices.reset(acknowledgement.choices);
		return acknowledgement;
	},
	getCustomFieldType: function () {
		let result = {
			type: '',
			isMultipleChoice: false
		}
		switch (this.get('type').toLowerCase()) {
			case 'money':
			case 'date':
			case 'text':
			case 'textarea':
				result.type = this.get('type').toUpperCase();
				break;
			case 'single choice':
			case 'multiple choice':
				result.isMultipleChoice = true;
				result.type = PJQ.constants.customFields.fieldTypes.CHOICE;
				break;
			case 'numeric':
				result.type = PJQ.constants.customFields.fieldTypes.INT;
				break;
			case 'yes/no':
				result.type = PJQ.constants.customFields.fieldTypes.BOOL;
				break;
		}
		return result;
	},
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'acknowledgements',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.acknowledgementTypes[0],
		isRequired: false
	}
});

PJQ.models.bidForms.Bonding = PJQ.models.bidForms.Acknowledgement.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'bonding',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.bondingTypes[0],
		isRequired: false
	}
});

PJQ.models.bidForms.Certification = PJQ.models.bidForms.Acknowledgement.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'certifications',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.certificationTypes[0],
		isRequired: false
	}
});

PJQ.models.bidForms.LaborRate = PJQ.models.bidForms.Acknowledgement.extend({
	idAttribute: 'id',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.get('bidFormId')
			},
			{
				endpoint: 'laborrates',
				value: this.id
			}
		])
	},
	defaults: {
		description: "",
		type: PJQ.helpers.bidForms.laborRateTypes[0],
		isRequired: false
	}
});

//Collections
PJQ.collections.bidForms.Templates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Template,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'templates'
			}
		])
	}
});

PJQ.collections.bidForms.BidFormsSummary = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.BidFormSummary,
	endpoint: function () {
		if (this.options.templateId > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'bidforms'
				},
				{
					endpoint: 'templates',
					value: this.options.templateId
				},
				{
					endpoint: 'summary'
				}
			]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.projectId
			},
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'summary'
			}
		]);
	},
	export: function (groupIds) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.projectId
				},
				{
					endpoint: 'bidforms'
				},
				{
					endpoint: 'summary'
				}
			], [
				{
					parameter: 'export',
					value: true
				},
				{
					parameter: 'groupIds',
					value: groupIds
				}
			]),
			isApi2: true
		}).get().done(_.bind(function (response) {
			PJQ.files.downloadFile(response.url, {
				isEndpoint: false
			});
		}, this)).fail(_.bind(function (xhr, err, result) {
		}, this));
	},
	deleteList: function (groupIds, callback) {
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.options.projectId
				},
				{
					endpoint: 'bidforms'
				},
				{
					endpoint: 'delete'
				}
			], [
				{
					parameter: 'groupIds',
					value: groupIds
				}
			]),
			isApi2: true
		}).delete().done(_.bind(function (response) {
			callback();
		}, this)).fail(_.bind(function (xhr, err, result) {
		}, this));
	}
});

PJQ.collections.bidForms.GroupBidForms = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.GroupBidForm,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'bidforms'
			}
		]);
	},
	beforeConstruct: function (models) {
		this.projectBidForm = new PJQ.models.bidForms.ProjectBidForm(models.projectBidForm ? models.projectBidForm : {});
	},
	parse: function (response) {
		if (response.projectBidForm)
			this.projectBidForm.set(response.projectBidForm);
		return response.groupBidForms;
	},
	getSelectedGroupIds: function () {
		let selectedGroupIds = [];
		_.each(this.models, function (model) {
			selectedGroupIds.push(model.get('group').groupId);
		});
		return selectedGroupIds;
	},
	addGroups: function (groups, radius, success, error) {
		let groupIds = [];
		_.each(groups, function (group) {
			groupIds.push(group.get('groupId'));
		});

		let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: PJQ.app.session.project.id
			},
			{
				endpoint: 'bidforms'
			},
			{
				endpoint: 'bidders'
			}
		]);
		let request = new PJQ.ajax.Request({
			endpoint: endpoint,
			data: {
				projectId: PJQ.app.session.project.id,
				groupIds: groupIds,
				radius: radius
			}
		});
		request.post().done(_.bind(function (data) {
			this.fetchReset();
			success(data);
		}, this)).fail(function () {
			error();
		});
	}
});

PJQ.collections.bidForms.LineItems = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.LineItem,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'lineitems'
			}
		])
	}
});

PJQ.collections.bidForms.Alternates = PJQ.collections.bidForms.LineItems.extend({
	model: PJQ.models.bidForms.Alternate,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'alternates'
			}
		])
	}
});

PJQ.collections.bidForms.Acknowledgements = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Acknowledgement,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'acknowledgements'
			}
		])
	}
});

PJQ.collections.bidForms.Bonding = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Bonding,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'bonding'
			}
		])
	}
});

PJQ.collections.bidForms.Certifications = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.Certification,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'certifications'
			}
		])
	}
});

PJQ.collections.bidForms.LaborRates = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.bidForms.LaborRate,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidforms',
				value: this.options.bidFormId
			},
			{
				endpoint: 'laborrates'
			}
		])
	}
});

PJQ.views.bidForms.BidFormEditorSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Selector'),
        subTemplates: {
            editorSelectorGroupBidForms: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Selector-Group-BidForms')
        },
        bidFormTemplate: null
    },
    events: {
        "click .bid-form-project-links a": "selectProjectBidForm",
        "keyup .bid-form-group-search": "renderGroupBidForms",
        "click .bid-form-group": "selectGroup",
        "click .bid-form-add-bidders-simple": "addBiddersSimple",
        "click .bid-form-add-bidders-per-contact": "addBiddersFromContacts",
        "click .btn-add-trades": "addTrades",
        "click .bid-form-add-bidders-project": "addBiddersFromProject",
        "click .bid-form-new-contact": "newContact",
        "click .export-project-bid-forms": "exportBidForms",
        "click .btn-bid-form-settings": "viewSettings",
        "click .btn-save-as-template": "saveAsTemplate",
        "click .btn-import-template": "importTemplate",
        "click .btn-seal-bids": "sealBids",
        "click .btn-view-sealed-bid-contacts": "viewSealedBidContacts",
        "click .btn-unseal-bids": "unsealBids"
    },
    beforeFirstRender: function () {
        let fnSettings;
        if (this.options.project != null) {
            fnSettings = _.bind(this.options.project.fetchBidFormSettings, this.options.project);
        } else {
            fnSettings = _.bind(PJQ.app.session.fetchBidFormSettings, PJQ.app.session);
        }

        fnSettings(_.bind(function (settings) {
            this.options.settings = settings;
            if (this.options.bidFormTemplate != null) {
                this.collection = this.options.bidFormTemplate.groupBidForms;
                this.collection.isFetched = true;
                this.render();
            } else {
                this.listenTo(this.collection, "reset", this.render);
                this.collection.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this),
                    error: _.bind(function () {
                        this.render();
                    }, this)
                });
            }
        }, this));
    },
    beforeRender: function () {
        if (this.collection && this.collection.projectBidForm) {
            this.projectBidForm = this.collection.projectBidForm;
        } else if (this.collection == null && this.options.bidFormTemplate) {
            this.collection = this.options.bidFormTemplate.groupBidForms;
            this.collection.isFetched = true;
        }
    },
    renderData: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('messaging.canManage') : true;
        return {
            collection: this.collection,
            template: this.options.bidFormTemplate,
            project: this.options.project,
            canEdit: this.options.canEdit,
            settings: this.options.settings,
            isBidFormAdmin: this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : false
        };
    },
    afterRender: function () {
        if (!this.collection || !this.collection.isFetched) {
            this.loader = new PJQ.Loader(this.$('.bid-form-select-container'));
            return;
        } else if (this.loader) {
            this.loader.remove();
        }

        this.searchBar = this.$('.bid-form-group-search');
        this.renderGroupBidForms();

        if (_.size(this.collection.models) > 0 && this.options.initProposalId > 0) {
            PJQ.app.options.initProposal = new PJQ.models.bidForms.Proposal({
                projectId: PJQ.app.session.project.id,
                proposalId: this.options.initProposalId
            });
            PJQ.app.options.initProposal.fetch({
                success: _.bind(function () {
                    let bidForm = _.find(this.collection.models, function (model) {
                        return model.get('bidFormId') === PJQ.app.options.initProposal.get('bidFormId');
                    }, this);
                    if (bidForm != null) {
                        this.renderSubview(bidForm.id);
                    }
                }, this)
            });
            this.options.initProposalId = null;
        } else if (_.size(this.collection.models) > 0 && this.options.initGroupId > 0) {
            this.selectedBidForm = _.find(this.collection.models, function (bidForm) {
                if (bidForm.bidPackage != null) {
                    return bidForm.bidPackage.get('bidPackageId') === this.options.initGroupId;
                }
                return bidForm.get('groupId') === this.options.initGroupId;
            }, this);
            if (this.selectedBidForm != null) {
                this.renderBidFormEditor();
            }
            this.options.initBidFormId = null;
        } else {
            this.renderSubview();
        }
    },
    renderGroupBidForms: function (refresh) {
        let fnContinue = _.bind(function() {
            let data = {
                models: this.getFilteredGroupBidForms(),
                selectedBidForm: this.selectedBidForm
            };
            this.renderSubTemplate(false, this.options.subTemplates.editorSelectorGroupBidForms, this.$('.bid-form-group-selector-container'), data);
        }, this);

        if (refresh) {
            this.collection.fetch({
                success: _.bind(function () {
                    this.render();
                }, this),
                error: _.bind(function () {
                    this.render();
                }, this)
            });
        }
        else
            fnContinue();
    },
    getFilteredGroupBidForms: function () {
        let search = this.searchBar.length > 0 ? this.searchBar.val().toLowerCase().trim() : "",
            sortedModels;
        if (this.options.settings.get('isUsingBidPackages') || (this.options.bidFormTemplate != null && this.options.bidFormTemplate.get('bidPackageTemplateId'))) {
            sortedModels = _.sortBy(this.collection.models, function (model) {
                return model.get('bidPackage').name;
            })
        } else {
            sortedModels = sortedModels = _.sortBy(this.collection.models, function (model) {
                return model.get('group').groupName;
            })
        }
        return _.filter(sortedModels, function (model) {
            if (model.get('bidPackageId') > 0 && model.get('bidPackage') != null) {
                return model.get('bidPackage') && model.get('bidPackage').name.toLowerCase().indexOf(search) > -1;
            } else {
                return model.get('group') && model.get('group').groupName && model.get('group').groupName.toLowerCase().indexOf(search) > -1;
            }
        }, this);
    },
    renderSubview: function (id) {
        if (id != null) {
            this.selectedBidForm = this.collection.get({cid: id});
            this.renderBidFormEditor();
        } else {
            this.selectedBidForm = null;
            this.renderBidFormsSummary();
        }
    },
    clearSubView: function () {
        if (this.bidFormEditor) {
            this.bidFormEditor.undelegateEvents();
            this.bidFormEditor.stopListening();
        }

        if (this.summaryView) {
            this.summaryView.undelegateEvents();
            this.summaryView.stopListening();
        }
    },
    renderBidFormsSummary: function () {
        if (this.options.project != null) {
            PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms', {
                trigger: false
            });
        }

        this.clearSubView();

        let summary = new PJQ.collections.bidForms.BidFormsSummary(null, {
            templateId: this.options.bidFormTemplate ? this.options.bidFormTemplate.id : null,
            projectId: this.options.project ? this.options.project.id : null
        });
        summary.fetch({
            success: _.bind(function () {
                this.summaryView = new PJQ.views.bidForms.BidFormsSummary({
                    el: this.$('.bid-form-editor'),
                    collection: summary,
                    settings: this.options.settings,
                    project: this.options.project,
                    bidFormTemplate: this.options.bidFormTemplate,
                    onDeleteBidForm: _.bind(function (model) {
                        if (!this.options.settings.get('isUsingBidPackages'))
                            this.collection.remove(model.id);
                        this.renderGroupBidForms(this.options.settings.get('isUsingBidPackages'));
                    }, this),
                    onDeleteBidForms: _.bind(function () {
                        this.renderGroupBidForms(true);
                    }, this),
                    onViewBidForm: _.bind(function (model, view) {
                        this.selectedBidForm = this.collection.get(model.id);
                        this.renderBidFormEditor(view);
                    }, this)
                });
            }, this)
        });
    },
    renderBidFormEditor: function (activeView = null) {
        if (this.options.project != null) {
            if (this.selectedBidForm.get('groupId') > 0) {
                PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms/' + this.selectedBidForm.get('groupId'), {
                    trigger: false
                });
            } else if (this.selectedBidForm.get('bidPackageId') > 0) {
                PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms/' + this.selectedBidForm.get('bidPackageId'), {
                    trigger: false
                });
            } else {
                PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/bidforms', {
                    trigger: false
                });
            }
        }

        if (activeView == null && this.bidFormEditor != null) {
            activeView = this.bidFormEditor.getActiveView();
        }

        this.clearSubView();

        let fnRender = _.bind(function () {

            this.$('.bid-form-group[data-cid="' + this.selectedBidForm.cid + '"]').find('.unviewed-proposal-count').remove();
            this.bidFormEditor = new PJQ.views.bidForms.BidFormEditorContainer({
                el: this.$('.bid-form-editor'),
                project: this.options.project,
                model: this.selectedBidForm,
                projectBidForm: this.projectBidForm,
                settings: this.options.settings,
                activeView: activeView,
                collection: this.collection
            });

            $('.nav-content').scrollTop(0);
        }, this);
        if (this.selectedBidForm != null) {
            let groupsNavContainer = this.$('.bid-form-group-selector-container');
            groupsNavContainer.find('.nav-link').removeClass('active').removeClass('remove');
            groupsNavContainer.find('.nav-link[data-cid="' + this.selectedBidForm.cid + '"]').addClass('active show');

            this.selectedBidForm.fetch({
                success: _.bind(function () {
                    fnRender();
                }, this)
            });
        } else {
            fnRender();
        }
    },
    selectGroup: function (e) {
        let target = $(e.currentTarget);
        this.renderSubview(target.data('cid'));
    },
    selectProjectBidForm: function (e) {
        this.$('.bid-form-group').removeClass('active');
        let bidFormTarget = $(e.currentTarget).data('target');
        this.renderBidFormEditor();
        $('body').animate({
            scrollTop: $('.' + bidFormTarget).offset().top
        });
    },
    addBiddersSimple: function () {
        let showUnionStatus = true;
        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS)) {
            showUnionStatus = !PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS);
        }
        new PJQ.views.projectParticipants.AddParticipantsModal({
            model: PJQ.app.session.project,
            isUnionStatusEnabled: showUnionStatus,
            isDirectoryEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_DIRECTORY),
            onSave: _.bind(function () {
                this.collection.fetchReset();
            }, this)
        });
    },
    addBiddersFromContacts: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.CONTACTS,
            isSingleChoice: false,
            subtitle: "Add Participants From Address Book",
            onSave: _.bind(function (selectedContacts) {
                PJQ.app.session.project.addParticipantsById(selectedContacts, _.bind(function () {
                    this.collection.fetchReset();
                }, this));
            }, this)
        });
    },
    addTrades: function () {
        let endpoint;
        if (this.options.bidFormTemplate) {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'bidforms'
                },
                {
                    endpoint: 'templates',
                    value: this.options.bidFormTemplate.id
                },
                {
                    endpoint: 'bidforms'
                }
            ]);
            if (this.options.bidFormTemplate.get('bidPackageTemplateId')) {
                new PJQ.views.bidPackages.EditTemplateModal({
                    templateId: this.options.bidFormTemplate.get('bidPackageTemplateId'),
                    onClose: _.bind(function () {
                        this.renderBidFormsSummary();
                        this.renderGroupBidForms()
                    }, this)
                });
            } else {
                new PJQ.views.groups.SelectGroupsModal({
                    selectorOptions: {
                        disabledGroupIds: _.uniq(_.map(this.collection.models, function (bidForm) {
                            return bidForm.get('groupId');
                        }))
                    },
                    onSave: _.bind(function (groups) {
                        new PJQ.ajax.Request({
                            endpoint: endpoint,
                            data: {
                                groupIds: _.map(groups.new, function (group) {
                                    return group.id;
                                })
                            }
                        }).post().done(_.bind(function () {
                            if (this.options.bidFormTemplate != null) {
                                this.options.bidFormTemplate.fetch({
                                    success: _.bind(function () {
                                        this.collection = this.options.bidFormTemplate.groupBidForms;
                                        this.collection.isFetched = true;
                                        this.render();
                                    }, this)
                                })
                            } else {
                                this.collection.fetchReset();
                            }
                        }, this));
                    }, this)
                });
            }
        } else {
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'bidforms'
                }
            ]);

            if (this.options.settings.get('isUsingBidPackages') || (this.options.bidFormTemplate != null && this.options.bidFormTemplate.get('bidPackageTemplateId'))) {
                new PJQ.views.bidPackages.ManageBidPackagesModal({
                    project: this.options.project,
                    onClose: _.bind(function (data) {
                        if (data.changed) {
                            this.collection.fetch({
                                success: _.bind(function () {
                                    this.render();
                                }, this)
                            })
                        }
                    }, this)
                })
            } else if (this.options.project) {
                let bidPackages = new PJQ.collections.bidPackages.BidPackages(null, {
                        projectId: this.options.project ? this.options.project.id : null
                    }),
                    fnSelectGroups = _.bind(function () {
                        new PJQ.views.groups.SelectGroupsModal({
                            selectorOptions: {
                                disabledGroupIds: _.uniq(_.map(this.collection.models, function (bidForm) {
                                    return bidForm.get('groupId');
                                }))
                            },
                            onSave: _.bind(function (groups) {
                                new PJQ.ajax.Request({
                                    endpoint: endpoint,
                                    data: {
                                        groupIds: _.map(groups.new, function (group) {
                                            return group.id;
                                        })
                                    }
                                }).post().done(_.bind(function () {
                                    if (this.options.bidFormTemplate != null) {
                                        this.options.bidFormTemplate.fetch({
                                            success: _.bind(function () {
                                                this.collection = this.options.bidFormTemplate.groupBidForms;
                                                this.collection.isFetched = true;
                                                this.render();
                                            }, this)
                                        })
                                    } else {
                                        this.collection.fetchReset();
                                    }
                                }, this));
                            }, this)
                        });
                    }, this);
                bidPackages.fetch({
                    success: _.bind(function (collection) {
                        if (_.size(collection.models) > 0) {
                            new PJQ.views.modals.YesNo({
                                header: "Bid Packages Exist",
                                body: "Bid Packages currently exist on this project. Would you like to use bid packages on bid forms instead of individual trades?",
                                onYes: _.bind(function () {
                                    let settings = this.options.settings;
                                    settings.set('isUsingBidPackages', true);
                                    settings.save();
                                    new PJQ.views.bidPackages.ManageBidPackagesModal({
                                        project: this.options.project,
                                        onClose: _.bind(function () {
                                            this.collection.fetch({
                                                success: _.bind(function () {
                                                    this.render();
                                                }, this)
                                            });
                                        }, this)
                                    })
                                }, this),
                                onNo: _.bind(function () {
                                    fnSelectGroups();
                                }, this),
                            });
                        } else {
                            fnSelectGroups();
                        }
                    }, this)
                });
            } else {
                fnSelectGroups();
            }
        }
    },
    addBiddersFromProject: function () {
        new PJQ.views.projectParticipants.AddParticipantsFromProjectModal({
            model: PJQ.app.session.project,
            isBidFormsEnabled: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_FORMS),
            onSave: _.bind(function () {
                this.collection.fetchReset();
            }, this)
        });
    },
    newContact: function () {
        new PJQ.views.contacts.BaseEditContactModal({
            model: new PJQ.models.projectParticipants.ProjectParticipant({
                projectId: PJQ.app.session.project.id,
                country: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.ADDRESS_BOOK_DEFAULT_COUNTRY) : 'US'
            }),
            onSave: _.bind(function () {
                this.collection.fetchReset();
            }, this)
        });
    },
    exportBidForms: function () {
        PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'proposals'
            },
            {
                endpoint: 'export'
            }
        ]));
    },
    viewSettings: function () {
        new PJQ.views.bidForms.BidFormSettingsModal({
            project: this.options.project,
            model: this.options.settings,
            onSave: _.bind(function () {
                this.collection.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    saveAsTemplate: function () {
        new PJQ.views.bidForms.SaveAsTemplateModal({
            project: PJQ.app.session.project
        });
    },
    importTemplate: function () {
        new PJQ.views.bidForms.ImportTemplateModal({
            project: PJQ.app.session.project,
            onImport: _.bind(function (bidForm, settings) {
                if (settings != null) {
                    this.options.settings = settings;
                }
                this.collection.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this),
                    error: _.bind(function () {
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    sealBids: function() {
        this.options.project.fetchProjectContacts(_.bind(function(result) {
            let projectContacts = _.filter(result.models, function(contact) {
                return contact.get('id') < 0;
            });

            if (_.size(projectContacts) == 0 && !this.options.settings.get('isSealBids')) {
                new PJQ.views.BaseModal({
                    header: "Cannot Seal Bids",
                    body: "Please assign Company Users to Project Contacts before sealing bids for this project."
                });
            } else {
                new PJQ.views.bidForms.SealedBidContactsModal({
                    projectContacts: new PJQ.collections.projectContacts.ProjectContacts(projectContacts),
                    selectedProjectContacts: null,
                    isEdit: !this.options.settings.get('isSealBids'),
                    onSealBids: _.bind(function(contacts) {
                        this.options.settings.set('isSealBids', true);
                        this.options.settings.set('sealedBidContactList', contacts);
                        this.options.settings.save({},{
                            success: _.bind(function() {
                                this.render();
                                PJQ.notifications.notify.successNotify({
                                    message: 'Bids sealed for project.'
                                });
                            }, this)
                        });
                    }, this)
                });
            }
        }, this));
    },
    viewSealedBidContacts: function() {
        new PJQ.views.bidForms.SealedBidContactsModal({
            projectContacts: null,
            selectedProjectContacts: new PJQ.collections.projectContacts.ProjectContacts(this.options.settings.get('sealedBidContactList')),
            isEdit: false
        });
    },
    unsealBids: function() {
        new PJQ.views.modals.YesNo({
            header: "Unseal Bids",
            body: "Are you sure you want to unseal bids for this project?",
            onYes: _.bind(function () {
                this.options.settings.set('isSealBids', false);
                this.options.settings.set('sealedBidContactList', []);
                this.options.settings.save({},{
                    success: _.bind(function() {
                        this.render();
                        PJQ.notifications.notify.successNotify({
                            message: 'Bids unsealed for project.'
                        });
                    }, this)
                });
            }, this)
        });

    }
});

PJQ.views.bidForms.BidFormsSummary = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bid-Forms-Summary'),
        onViewBidForm: null,
        onDeleteBidForm: null
    },
    events: {
        'click .btn-view-bid-form': 'viewBidFormClicked',
        'click .btn-view-participants': 'viewParticipantsClicked',
        'click .btn-view-proposals': 'viewProposalsClicked',
        'change .select-all-groups': 'selectAllGroups',
        'change .select-group': 'selectGroup',
        'click .btn-export-all': 'exportAll',
        'click .btn-export-select': 'startExport',
        'click .btn-export-selected': 'exportSelected',
        'click .btn-cancel-export': 'cancelExport',
        'click .btn-bid-form-delete': 'deleteBidForm',
        'click .btn-cancel-delete': 'cancelDelete',
        'click .btn-delete-select': 'startDelete',
        'click .btn-delete-selected': 'deleteSelected'
    },
    deleteBidForm: function (e) {
        let bidForm = this.dataTable.getRow($(e.currentTarget)).data();

        let body = "Are you sure you want to delete this bid form?<br /><br /><strong>Note:</strong> All proposals for this bid form will be deleted.  This groups will also be removed from all participants on this project.  Participants who are only in this group will be removed from the project.";
        if (this.options.settings.get('isUsingBidPackages'))
            body = "Are you sure you want to delete this bid package?<br /><br /><strong>Note:</strong> All line items and proposals for this bid package will be deleted.   The bid package will still appear in the summary after being deleted.  To remove it permanently, click Manage Bid Packages.";

        if (bidForm != null) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: body,
                onDelete: _.bind(function () {
                    let groupName = '',
                        row = this.dataTable.getRow(bidForm.cid);
                    if (bidForm.get('group') != null) {
                        groupName = bidForm.get('group').groupName;
                    } else if (bidForm.get('bidPackage') != null) {
                        groupName = bidForm.get('bidPackage').name;
                    }

                    if (!this.options.settings.get('isUsingBidPackages'))
                        this.collection.remove(bidForm);

                    bidForm.destroy( {
                        success: _.bind(function() {
                            if (row != null && !this.options.settings.get('isUsingBidPackages')) {
                                this.dataTable.removeRow(row);
                            }

                            PJQ.notifications.notify.successNotify({
                                message: groupName + ' bid form deleted'
                            });

                            if (typeof this.options.onDeleteBidForm === 'function') {
                                this.options.onDeleteBidForm(bidForm);
                            }
                            this.render();
                        }, this)
                    });
                }, this)
            });
        }
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
    },
    afterRender: function () {
        this.selectedGroupIds = [];

        let groupColumn;
        if (this.collection.models.length > 0 && this.collection.models[0].get('bidPackage')) {
            groupColumn = {
                data: "attributes.bidPackage",
                title: "Bid Package",
                "render": function (data) {
                    return data.name;
                }
            }
        } else {
            groupColumn = {
                data: "attributes.group",
                title: "Trade",
                "render": function (data) {
                    return data.groupName;
                }
            }
        }
        let managedByColumn = {
                data: "attributes.managedBy",
                title: "Managed By",
                render: function (data, type, row) {
                    let result = '';
                    if (row.managedBy != null) {
                        return PJQ.helpers.contacts.getContactAnchor({contact: row.managedBy});
                    } else {
                        result = 'Nobody';
                    }
                    return result;
                }
            },
            estimateColumn = {
                data: "attributes.estimate",
                title: "Estimate",
                render: function (data, type, row) {
                    let result = '';
                    if (row.get('estimate') != null) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('estimate'));
                    } else {
                        result = '-';
                    }
                    return result;
                }
            },
            editColumn = {
                data: "attributes.bidFormId",
                title: "",
                width: '80px',
                orderable: false,
                searchable: false,
                className: 'text-align-center',
                render: _.bind(function () {
                    if (this.options.isExport || this.options.isDelete)
                        return '';

                    let result = '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-bid-form"><i class="fal fa-eye"></i></button>';
                    if (this.options.canEdit && !this.options.settings.get('isSealBids')) {
                        result += '<button type="button" class="btn btn-danger btn-bid-form-delete ml-1"><span class="fal fa-trash"></span></button>'
                    }
                    result += '</div>';

                    return result;
                }, this)
            };
        let columns = [];
        if (this.options.isExport || this.options.isDelete) {
            columns.push({
                "columnData": 'selectGroup',
                "title": '<div class="pretty p-default"><input type="checkbox" class="select-all-groups" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>',
                "width": "20px",
                "data": "null",
                "orderable": false,
                "searchable": false,
                "render": _.bind(function (data, type, row) {
                    let isSelected = this.selectedGroupIds.indexOf(row.get('groupId')) !== -1 || this.selectedGroupIds.indexOf(-row.get('bidPackageId')) !== -1;
                    return '<div class="pretty p-default"><input type="checkbox" ' + (isSelected ? 'checked' : '') + ' data-group-id="' + row.get('groupId') + '" data-bid-package-id="' + row.get('bidPackageId') + '" class="select-group" /><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div>';
                }, this)
            });
        }
        if (this.options.project != null) {
            columns.push(...[
                groupColumn,
                managedByColumn,
                {
                    "data": "attributes.dueDate",
                    "title": "Bids Due",
                    "searchable": false,
                    "width": '150px',
                    "render":
                        function (data) {
                            if (data != null) {
                                let dueDate = new Date(data);
                                return PJQ.helpers.dateHelpers.getDateString(dueDate, PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                            }
                            return 'Not Set';
                        }
                },
                {
                    "data": "attributes.biddersCount",
                    "title": "Participants",
                    "searchable": false,
                    "render":
                        function (data) {
                            let result;
                            if (data) {
                                result = '<a href="javascript:void(0)" class="btn-view-participants">' + data.toString() + '</a>';
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                },
                {
                    "data": "attributes.submittedProposalsCount",
                    "title": "Proposals",
                    "searchable": false,
                    "render":
                        function (data) {
                            let result;
                            if (data) {
                                result = '<a href="javascript:void(0)" class="btn-view-proposals">' + data.toString() + '</a>';
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                },
                estimateColumn
            ]);

            if (!this.options.settings.get('isHideTotal')) {
                columns.push(...[
                    {
                        data: "attributes.lowestProposalTotal",
                        title: "Apparent Low",
                        render: function (data) {
                            let result;
                            if (data) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                    },
                    {
                        data: "attributes.awardedProposalTotal",
                        title: "Awarded",
                        render: function (data) {
                            let result;
                            if (data) {
                                return PJQ.helpers.formatHelpers.formatCurrency(data);
                            } else {
                                result = '-';
                            }
                            return result;
                        }
                    }
                ]);
            }

            columns.push(editColumn);
        } else {
            columns.push(...[
                groupColumn,
                estimateColumn,
                editColumn
            ]);
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.bid-forms-summary'),
            rowId: "cid",
            data: _.sortBy(this.collection.models, _.bind(function(model) {
                if (this.options.settings.get('isUsingBidPackages') || (this.options.bidFormTemplate != null && this.options.bidFormTemplate.get('bidPackageTemplateId'))) {
                    return model.get('bidPackage').name;
                } else {
                    return model.get('group').groupName;
                }
            }, this)),
            order: [[(this.options.isExport ? 1 : 0), "asc"]],
            paging: false,
            deferRender: true,
            onRowDoubleClick: _.bind(function (row) {
                this.viewBidForm(row.data());
            }, this),
            subTemplates: {
                header: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'data-table-header-bid-forms-summary')
            },
            headerData: _.bind(function () {
                return {
                    isExport: this.options.isExport,
                    canExport: !this.options.settings.get('isSealBids') || this.options.settings.isSealedBidContact(PJQ.app.session.user.get('id')),
                    collection: this.collection,
                    isUsingBidPackages: this.options.settings.get('isUsingBidPackages'),
                    canDelete: this.options.canEdit && !this.options.settings.get('isSealBids'),
                    isDelete: this.options.isDelete
                };
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View Proposals',
                        onClick: _.bind(function (row) {
                            this.viewBidForm(row.data(), 'PROPOSALS');
                        }, this)
                    }
                ]
            },
            columns: columns
        });
    },
    viewBidFormClicked: function (e) {
        let $target = $(e.currentTarget).closest('tr'),
            row = this.dataTable.getRow($target),
            bidForm = row.data();

        if (bidForm == null) {
            let parent = $($($(e.currentTarget)[0].parentElement)[0].parentElement)[0],
                row = this.dataTable.getRow(parent),
                bidForm = row.data();

            this.viewBidForm(bidForm);
        } else {
            this.viewBidForm(bidForm);
        }
    },
    viewParticipantsClicked: function (e) {
        this.viewBidForm(this.dataTable.getRow($(e.currentTarget)).data(), 'PARTICIPANTS');
    },
    viewProposalsClicked: function (e) {
        this.viewBidForm(this.dataTable.getRow($(e.currentTarget)).data(), 'PROPOSALS');
    },
    viewBidForm: function (bidForm, view = null) {
        if (this.options.onViewBidForm != null) {
            this.options.onViewBidForm(bidForm, view);
        }
    },
    selectGroup: function (e) {
        let $c = $(e.currentTarget),
            checked = $c.prop('checked'),
            groupId = parseInt($c.data('groupId')),
            bidPackageId = parseInt($c.data('bidPackageId')),
            value = groupId ? groupId : -bidPackageId;

        if (checked && this.selectedGroupIds.indexOf(value) === -1) {
            this.selectedGroupIds.push(value);
        } else {
            this.selectedGroupIds = _.without(this.selectedGroupIds, value);
        }
    },
    selectAllGroups: function (e) {
        let checked = $(e.currentTarget).prop('checked');
        if (checked) {
            this.selectedGroupIds = _.map(this.collection.models, function (model) {
                return model.get('groupId') ? model.get('groupId') : model.get('bidPackageId');
            });
        } else {
            this.selectedGroupIds = [];
        }
        this.$('.select-group').prop('checked', checked);
    },
    startDelete: function () {
        this.options.isDelete = true;
        this.render();
        this.$('.btn-export-dropdown').prop('disabled', true);
    },
    cancelDelete: function () {
        this.options.isDelete = false;
        this.render();
        this.$('.btn-export-dropdown').prop('disabled', false);
    },
    deleteSelected: function () {
        if (_.size(this.selectedGroupIds) == 0) {
            new PJQ.views.BaseModal({
                header: "No Selection",
                body: "Please select 1 or more " + (this.options.settings.get('isUsingBidPackages') ? 'Bid Packages' : 'Trades' ) + " to delete."
            });
            return;
        }

        let body = "Are you sure you want to delete " + _.size(this.selectedGroupIds) + " bid forms?<br /><br /><strong>Note:</strong> All proposals for these bid forms will be deleted.  The groups will also be removed from all participants on this project.  Participants who are only in these groups will be removed from the project.";
        if (this.options.settings.get('isUsingBidPackages'))
            body = "Are you sure you want to delete " + _.size(this.selectedGroupIds) + " bid packages?<br /><br /><strong>Note:</strong> All line items and proposals for these bid packages will be deleted.   The bid packages will still appear in the summary after being deleted.  To remove them permanently, click Manage Bid Packages.";

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: body,
            onDelete: _.bind(function () {

                this.collection.deleteList(this.selectedGroupIds, _.bind(function() {
                    this.selectedGroupIds = [];
                    this.options.isDelete = false;
                    PJQ.notifications.notify.successNotify({
                        message: 'Bid Forms deleted successfully'
                    });
                    if (typeof this.options.onDeleteBidForms === 'function') {
                        this.options.onDeleteBidForms();
                    }
                    this.render();
                }, this));

            }, this)
        });
    },
    startExport: function () {
        this.options.isExport = true;
        this.render();
        this.$('.btn-delete-select').prop('disabled', true);
    },
    cancelExport: function () {
        this.options.isExport = false;
        this.render();
        this.$('.btn-delete-select').prop('disabled', false);
    },
    exportSelected: function () {
        if (_.size(this.selectedGroupIds) == 0) {
            new PJQ.views.BaseModal({
                header: "No Selection",
                body: "Please select 1 or more " + (this.options.settings.get('isUsingBidPackages') ? 'Bid Packages' : 'Trades' ) + " to export."
            });
            return;
        }

        this.collection.export(this.selectedGroupIds);
        this.selectedGroupIds = [];
        this.options.isExport = false;
        this.render();
        this.$('.btn-delete-select').prop('disabled', false);
    },
    exportAll: function () {
        this.collection.export();
    }
});

PJQ.views.bidForms.BidFormEditorContainer = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Container')
    },
    events: {
        'click .btn-edit-managed-by': 'editManagedBy',
        'click .btn-edit-bid-package-attachments': 'editAttachments',
        'click .btn-edit-bid-package-attachments-tags': 'editAttachmentsTags',
        'click .btn-view-drawing': 'viewDrawing'
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;

        if (this.model) {
            this.listenTo(this.model.bidders, 'sync change reset', this.renderTabCounts);
            this.listenTo(this.model.managedBy, 'sync change reset', this.renderManagedBy);
        }

        if (this.options.projectBidForm)
            this.projectBidForm = this.options.projectBidForm;
        if (this.options.project) {
            this.options.project.fetchVersions(_.bind(function (versions) {
                this.versions = versions;
                this.render();
            }, this));
        } else {
            this.render();
        }
    },
    renderData: function () {
        return {
            project: this.options.project,
            canEdit: this.options.canEdit,
            model: this.model,
            activeView: this.options.activeView,
            bidPackageAttachments: this.getBidPackageAttachments()
        };
    },
    afterRender: function () {
        if (this.options.canEdit && (this.versions == null || !this.versions.isFetched) && this.options.project) {
            return;
        }

        //this.options.activeView = null;

        this.editor = new PJQ.views.bidForms.BidFormEditor({
            el: this.$('#bidFormContainer'),
            project: this.options.project,
            canEdit: this.options.canEdit,
            settings: this.options.settings,
            model: this.model,
            projectBidForm: this.projectBidForm,
            collection: this.options.collection
        });

        if (this.model) {
            if (this.model.get('projectId') > 0) {
                new PJQ.inputs.DateEditorInput({
                    el: this.$('.bid-form-group-due-date'),
                    canEdit: this.options.canEdit,
                    value: this.model.getDueDate(),
                    label: "Bids Due",
                    nullText: "TBD",
                    extraLabelClasses: "text-dark font-weight-light",
                    onSave: _.bind(function (newValue) {
                        this.model.set('dueDate', newValue);
                        this.model.save();
                    }, this)
                });

                if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES)) {
                    if (this.model.bidPackage != null) {
                        if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_BID_PACKAGES_COUNT)) {
                            new PJQ.inputs.TextAreaEditorInput({
                                el: this.$('.bid-form-bid-package-notes'),
                                canEdit: this.options.canEdit,
                                value: this.model.bidPackage.get('notes'),
                                label: "Notes",
                                nullText: "test",
                                extraLabelClasses: "text-dark font-weight-light",
                                onSave: _.bind(function (newValue) {
                                    this.model.bidPackage.set('notes', newValue);
                                    this.model.bidPackage.patch();
                                }, this)
                            })

                            new PJQ.inputs.Selectpicker({
                                el: this.$('.select-bid-package-count'),
                                defaultValue: this.model.bidPackage.get('count'),
                                onChange: _.bind(function (value) {
                                    this.model.bidPackage.set('count', value);
                                    this.model.bidPackage.patch();
                                }, this)
                            });
                        }
                    }
                }

                new PJQ.inputs.CurrencyEditorInput({
                    el: this.$('.bid-form-estimate'),
                    canEdit: this.options.canEdit,
                    value: this.model.get('estimate'),
                    onSave: _.bind(function (newValue) {
                        this.model.patch({
                            estimate: newValue
                        });
                        this.options.activeView = this.getActiveView();
                        this.render();
                    }, this)
                });

                if (PJQ.app.options.initProposal != null && !PJQ.app.options.initProposal.get('isShown')) {
                    this.$('#bidformProposalsTab').tab('show');
                    this.options.initProposal = null;
                }

                new PJQ.views.bidForms.Proposals({
                    el: this.$('#proposalsContainer'),
                    project: this.options.project,
                    collection: this.model.bidders,
                    bidForm: this.model,
                    settings: this.options.settings
                });

                new PJQ.views.bidForms.Bidders({
                    el: this.$('#biddersContainer'),
                    settings: this.options.settings,
                    project: this.options.project,
                    collection: this.model.bidders,
                    bidFormId: this.model.id
                });

                this.renderTabCounts();
            }
        }
    },
    getBidPackageAttachments: function () {
        let drawingIds,
            entryIds,
            tags;
        if (this.model.bidPackage != null) {
            drawingIds = _.map(_.filter(this.model.bidPackage.attachments.models, function (att) {
                return att.get('drawingId') > 0;
            }), function (att) {
                return att.get('drawingId');
            });

            entryIds = _.map(_.filter(this.model.bidPackage.attachments.models, function (att) {
                return att.get('entryId') > 0;
            }), function (att) {
                return att.get('entryId');
            });

            tags = _.map(_.filter(this.model.bidPackage.attachments.models, function (att) {
                return _.size(att.get('drawingTagName')) > 0;
            }), function (att) {
                return att.get('drawingTagName');
            });
        } else {
            drawingIds = [];
            entryIds = [];
            tags = [];
        }

        return {
            drawingIds: drawingIds,
            entryIds: entryIds,
            tags: tags
        }
    },
    viewDrawing: function (e) {
        let drawingId = parseInt($(e.currentTarget).data('drawingId')),
            version = null,
            drawing = null;
        _.each(this.versions.models, function (ver) {
            _.each(ver.drawings.models, function (dr) {
                if ((drawing == null || ver.id === -1) && dr.id === drawingId) {
                    version = ver;
                    drawing = dr;
                }
            }, this);
        }, this);
        if (version != null && drawing != null) {
            new PJQ.views.drawings.DrawingViewer({
                model: drawing,
                contextVersion: version,
                versions: this.versions
            });
        }
    },
    afterSync: function () {
        this.renderTabCounts();
        this.renderManagedBy();
    },
    renderTabCounts: function () {
        this.$('.badge-bidders').html(this.model.bidders.models.length);
        if (this.model.get('bidPackage') != null) {
            this.$('.badge-proposals').html(this.model.bidders.getProposalCount(null));
        } else {
            this.$('.badge-proposals').html(this.model.bidders.getProposalCount(this.model.id));
        }
    },
    renderManagedBy: function () {
        if (this.model.managedBy != null && this.model.managedBy.id !== 0) {
            this.$('.bid-form-managed-by-contact-name').find('.watch-contact-edit').text(this.model.managedBy.get('contactName')).data('contactId', this.model.managedBy.id);
        }
    },
    getActiveView: function () {
        switch ($('.tab-pane.active').attr('id')) {
            case 'biddersContainer':
                return 'PARTICIPANTS';
            case 'proposalsContainer':
                return 'PROPOSALS';
            default:
                return 'BIDFORM';
        }
    },
    editManagedBy: function () {
        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.USERS,
            hideContacts: this.model.managedBy,
            onSave: _.bind(function (contact) {
                this.model.managedBy = contact;
                this.renderManagedBy();
                this.model.save();
            }, this)
        });
    },
    editAttachments: function () {
        let selectedAttachments = this.getBidPackageAttachments();
        new PJQ.views.files.FileSelector({
            project: this.options.project,
            mode: 'SHARED',
            selectedEntryIds: selectedAttachments.entryIds,
            selectedDrawingIds: selectedAttachments.drawingIds,
            onSave: _.bind(function (attachments) {
                let entryIds = [],
                    drawingIds = [];
                _.each(attachments, function (attachment) {
                    if (attachment.get('entryId') > 0) {
                        entryIds.push(attachment.get('entryId'));
                    } else if (attachment.get('drawingId') > 0) {
                        drawingIds.push(attachment.get('drawingId'));
                    }
                })
                this.model.bidPackage.addAttachments(entryIds, drawingIds, selectedAttachments.tags, _.bind(function (attachments) {
                    this.render();
                }, this));
            }, this)
        });
    },
    editAttachmentsTags: function () {

    },
});

PJQ.views.bidForms.BidFormEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-BidForm'),
        subTemplates: {
            lineItems: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'editor-group-lineitems'),
            lineItem: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Group-LineItem'),
            alternate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Group-Alternate'),
            groupAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Group-Acknowledgement'),
            projectAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Acknowledgement'),
            bonding: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Bonding'),
            certification: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Certification'),
            laborRate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Editor-Project-Labor-Rate')
        },
        isEdit: false
    },
    events: {
        "click .bid-form-edit": "enableEdit",
        "click .bid-form-edit-cancel": "cancelEdit",
        "click .bid-form-save": "saveBidForm",
        "click .bid-form-preview": "previewBidForm",
        "click .add-group-line-item-button": "newGroupLineItem",
        "change .group-line-item-description,.group-line-item-category,.group-line-item-type,.group-line-item-default,.group-line-item-required,.group-line-item-readonly": "groupLineItemChanged",
        "click .delete-group-line-item-button": "deleteGroupLineItem",
        "click .add-group-alternate-button": "newGroupAlternate",
        "change .group-alternate-description,.group-alternate-category,.group-alternate-type,.group-alternate-default,.group-alternate-required,.group-alternate-readonly": "groupAlternateChanged",
        "click .delete-group-alternate-button": "deleteGroupAlternate",
        "click .add-group-acknowledgement-button": "newGroupAcknowledgement",
        "change .group-acknowledgement-description,.group-acknowledgement-category,.group-acknowledgement-type,.group-acknowledgement-required": "groupAcknowledgementChanged",
        "click .delete-group-acknowledgement-button": "deleteGroupAcknowledgement",
        "click .add-group-acknowledgement-choices-button": "addGroupAcknowledgementChoices",
        "click .add-project-acknowledgement-choices-button": "addProjectAcknowledgementChoices",
        "click .add-project-bonding-choices-button": "addProjectBondingChoices",
        "click .add-project-certification-choices-button": "addProjectCertificationChoices",
        "click .add-project-labor-rate-choices-button": "addProjectLaborRateChoices",
        "click .add-project-acknowledgement-button": "newProjectAcknowledgement",
        "change .project-acknowledgement-description,.project-acknowledgement-category,.project-acknowledgement-type,.project-acknowledgement-required": "projectAcknowledgementChanged",
        "click .delete-project-acknowledgement-button": "deleteProjectAcknowledgement",
        "click .add-project-bonding-button": "newProjectBonding",
        "change .project-bonding-description,.project-bonding-type,.project-bonding-required": "projectBondingChanged",
        "click .delete-project-bonding-button": "deleteProjectBonding",
        "click .add-project-certification-button": "newProjectCertification",
        "change .project-certification-description,.project-certification-type,.project-certification-required": "projectCertificationChanged",
        "click .delete-project-certification-button": "deleteProjectCertification",
        "click .add-project-labor-rate-button": "newProjectLaborRate",
        "change .project-labor-rate-description,.project-labor-rate-type,.project-labor-rate-required": "projectLaborRateChanged",
        "click .delete-project-labor-rate-button": "deleteProjectLaborRate",
        "click .bid-form-group-edit-due-date": "editBidFormDueDate",
        "click .copy-from": "copyFromOtherBidForm"
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? (this.options.project.hasPermission('bidForms.isAdmin') && !this.options.settings.get('isSealBids')) : true;
        if (this.model) {
            this.listenTo(this.model, "sync", this.render);
            this.isLoaded = false;
            if (this.model.id > 0) {
                this.model.fetch({
                    success: _.bind(function () {
                        this.isLoaded = true;
                    }, this),
                    error: _.bind(function () {
                        this.isLoaded = true;
                    }, this)
                });
            }
        }
        if (this.options.projectBidForm) {
            this.projectBidForm = this.options.projectBidForm;
            this.listenTo(this.projectBidForm, "sync", this.render);
            if (this.projectBidForm.id > 0) {
                this.projectBidForm.fetch({
                    success: _.bind(function () {
                        this.isLoaded = true;
                    }, this),
                    error: _.bind(function () {
                        this.isLoaded = true;
                    }, this)
                });
            }
        }
    },
    beforeRender: function () {
        this.renderData = {
            model: this.model,
            canEdit: this.options.canEdit,
            projectBidForm: this.projectBidForm,
            dateHelpers: PJQ.helpers.dateHelpers,
            isEdit: this.options.isEdit
        };
    },
    afterRender: function () {
        if (this.model) {
            this.renderGroupLineItems();
            this.renderGroupAlternates();
            this.renderGroupAcknowledgements();

            this.otherBidForms = null;
            if (this.options.collection) {
                this.otherBidForms = _.filter(this.options.collection.models, _.bind(function(bidForm) {
                    if (bidForm.get('groupId') && this.model.get('groupId') && bidForm.get('groupId') === this.model.get('groupId'))
                        return false;

                    if (bidForm.get('bidPackageId') && this.model.get('bidPackageId') && bidForm.get('bidPackageId') === this.model.get('bidPackageId'))
                        return false;

                    /* line items aren't populated until the bidform is visited
                    if (_.size(bidForm.get('lineItems')) == 0)
                        return false;

                     */

                    return true;
                }, this));

                if (_.size(this.otherBidForms) === 0)
                    this.$('.copy-from').hide();

            } else {
                this.$('.copy-from').hide();
            }
        }
        if (this.projectBidForm) {
            this.renderProjectAcknowledgements();
            this.renderProjectBondings();
            this.renderProjectCertifications();
            this.renderProjectLaborRates();
        }

        if (!this.isLoaded) {
            this.loader = new PJQ.Loader(this.$el);
        } else if (this.loader) {
            this.loader.remove();
        }
    },
    copyFromOtherBidForm: function() {
        new PJQ.views.bidPackages.CopyBidFormModal({
            isBidPackage: !this.model.get('groupId'),
            otherBidForms: this.otherBidForms,
            onCopy: _.bind(function(bidForm, copyLineItems, copyAlternates, copyAcknowledgements) {
                if (copyLineItems) {
                    _.each(bidForm.lineItems.models, _.bind(function(lineItem) {
                        this.model.set('isChanged', true);

                        let newLineItem = new PJQ.models.bidForms.LineItem({
                            bidFormId: this.model.id,
                            isNew: true,
                            sortOrder: _.size(this.model.lineItems) + 1,
                            description: lineItem.get('description'),
                            category: lineItem.get('category'),
                            defaultValue: lineItem.get('defaultValue'),
                            isRequired: lineItem.get('isRequired'),
                            isReadOnly: lineItem.get('isReadOnly'),
                            type: lineItem.get('type')
                        });

                        this.model.lineItems.add(newLineItem);
                    }, this));

                    this.model.set('lineItems', this.model.lineItems);
                    this.renderGroupLineItems();
                }

                if (copyAlternates) {
                    _.each(bidForm.alternates.models, _.bind(function(alternate) {
                        this.model.set('isChanged', true);
                        let newAlternate = new PJQ.models.bidForms.Alternate({
                            bidFormId: this.model.id,
                            isNew: true,
                            sortOrder: _.size(this.model.alternates) + 1,
                            description: alternate.get('description'),
                            category: alternate.get('category'),
                            defaultValue: alternate.get('defaultValue'),
                            isRequired: alternate.get('isRequired'),
                            isReadOnly: alternate.get('isReadOnly'),
                            type: alternate.get('type')
                        });
                        this.model.alternates.add(newAlternate);
                    }, this));

                    this.model.set('alternates', this.model.alternates);
                    this.renderGroupAlternates();
                }

                if (copyAcknowledgements) {
                    _.each(bidForm.acknowledgements.models, _.bind(function(acknowledgement) {
                        this.model.set('isChanged', true);
                        let newAcknowledgement = new PJQ.models.bidForms.Acknowledgement({
                            bidFormId: this.model.id,
                            isNew: true,
                            sortOrder: _.size(this.model.acknowledgements) + 1,
                            description: acknowledgement.get('description'),
                            isRequired: acknowledgement.get('isRequired'),
                            type: acknowledgement.get('type')
                        });

                        if (acknowledgement.choices && acknowledgement.choices.models) {
                            newAcknowledgement.choices = new PJQ.collections.customFields.CustomFieldChoices();
                            _.each(acknowledgement.choices.models, _.bind(function(choice) {
                                newAcknowledgement.choices.add(new PJQ.models.customFields.CustomFieldChoice({
                                    value: choice.get('value'),
                                    sortOrder: choice.get('sortOrder'),
                                    isDeleted: choice.get('isDeleted')
                                }));
                            }, this));
                            newAcknowledgement.set('choices', newAcknowledgement.choices.models)
                        }

                        this.model.acknowledgements.add(newAcknowledgement);
                    },this));

                    this.model.set('acknowledgements', this.model.acknowledgements);
                    this.renderGroupAcknowledgements();
                }

                PJQ.notifications.notify.successNotify({
                    message: 'Items copied successfully'
                });
            }, this)
        });
    },
    previewBidForm: function () {
        this.model.preview(null, {
            projectBidForm: this.projectBidForm
        });
    },
    newGroupLineItem: function () {
        if (this.model)
            this.model.set('isChanged', true);
        let newLineItem = new PJQ.models.bidForms.LineItem({
            bidFormId: this.model.id,
            isNew: true,
            sortOrder: _.size(this.model.lineItems) + 1
        });
        this.model.lineItems.add(newLineItem);
        this.model.set('lineItems', this.model.lineItems);
        this.renderGroupLineItems();
    },
    // renderGroupLineItems: function () {
    //     let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
    //         groupLineItems = this.model.lineItems.models,
    //         $gli = this.$('.bid-form-group-line-items'),
    //         self = this;
    //     $gli.empty();
    //     let categories = _.uniq(_.map(groupLineItems, function (item) {
    //             let category = item.get('category');
    //             return category != null ? category : '';
    //         })),
    //         data = {
    //             lineItems: groupLineItems,
    //             categories: categories,
    //             isEdit: this.options.isEdit,
    //             hasProposals: hasProposals
    //         };
    //     this.renderSubTemplate(true, this.options.subTemplates.lineItems, this.$('.bid-form-group-line-items'), data, _.bind(function (content) {
    //         // if (lineItem.get('isNew'))
    //         // 	content.find('.group-line-item-description').focus();
    //         if (this.options.isEdit) {
    //             new PJQ.Sortable($gli, {
    //                 items: '.group-line-item-row',
    //                 connectWith: '.group-line-item-row',
    //                 multiple: true,
    //                 handle: '.group-line-item-sort',
    //                 onStop: function () {
    //                     self.setGroupLineItemSort();
    //                 }
    //             });
    //         }
    //     }, this));
    // },
    renderGroupLineItems: function () {
        let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
            groupLineItems = this.model.lineItems.models,
            $gli = this.$('.bid-form-group-line-items'),
            self = this;
        $gli.empty();
        _.each(_.sortBy(_.sortBy(groupLineItems, function (groupLineItem) {
            return groupLineItem.get('sortOrder');
        }), function (groupLineItem) {
            return groupLineItem.get('contactCompanyId');
        }), function (groupLineItem) {
            self.renderGroupLineItem(groupLineItem, hasProposals);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gli, {
                items: '.group-line-item-row',
                connectWith: '.group-line-item-row',
                multiple: true,
                handle: '.group-line-item-sort',
                onStop: function () {
                    self.setGroupLineItemSort();
                }
            });

            if(_.size(groupLineItems) > 0) {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('.group-line-item-category'),
                    source: _.bind(function (req, res) {
                        if (_.size(req.term) === 0) {
                            return [];
                        }
                        res(_.filter(_.map(groupLineItems, function (item) {
                            return item.get('category')
                        }), function (category) {
                            if (_.size(category) > 0 && category.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                                return category;
                            }
                        }));
                    }, this)
                });
            }

            PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.group-line-item-default'), 2);
        }
    },
    renderGroupLineItem: function (lineItem, hasProposals) {
        let data = {
            item: lineItem,
            isEdit: this.options.isEdit,
            hasProposals: hasProposals
        };
        this.renderSubTemplate(true, this.options.subTemplates.lineItem, this.$('.bid-form-group-line-items'), data, function (content) {
            if (lineItem.get('isNew'))
                content.find('.group-line-item-description').focus();
        });
    },
    setGroupLineItemSort: function () {
        let self = this;
        this.$('.group-line-item-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.model.lineItems.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    groupLineItemChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-line-item-row'),
            cid = row.data('cid'),
            description = row.find('.group-line-item-description').val(),
            type = row.find('.group-line-item-type').val(),
            category = row.find('.group-line-item-category').val(),
            defaultValue = parseInt(PJQ.helpers.formatHelpers.numbersOnly(row.find('.group-line-item-default').val())),
            isRequired = row.find('.group-line-item-required').prop('checked'),
            isReadOnly = row.find('.group-line-item-readonly').prop('checked'),
            model = this.model.lineItems.get({cid: cid});

        model.set({
            description: description,
            category: category,
            defaultValue: defaultValue > 0 ? defaultValue : null,
            isRequired: isRequired,
            isReadOnly: isReadOnly,
        });
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderGroupLineItems();
        }
    },
    deleteGroupLineItem: function (e) {
        let cid = $(e.currentTarget).closest('.group-line-item-row').data('cid');
        this.model.updateLineItemDeleted(cid, true);
        $(e.currentTarget).closest('.group-line-item-row').remove();
    },
    newGroupAlternate: function () {
        if (this.model)
            this.model.set('isChanged', true);
        let newAlternate = new PJQ.models.bidForms.Alternate({
            bidFormId: this.model.id,
            isNew: true,
            sortOrder: _.size(this.model.alternates) + 1
        });
        this.model.alternates.add(newAlternate);
        this.model.set('alternates', this.model.alternates);
        this.renderGroupAlternates();
    },
    renderGroupAlternates: function () {
        let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
            groupAlternates = this.model.alternates.models,
            $gal = this.$('.bid-form-group-alternates'),
            self = this;
        $gal.empty();
        _.each(_.sortBy(groupAlternates, function (groupAlternate) {
            return groupAlternate.get('sortOrder');
        }), function (groupAlternate) {
            self.renderGroupAlternate(groupAlternate, hasProposals);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gal, {
                items: '.group-alternate-row',
                connectWith: '.group-alternate-row',
                multiple: true,
                handle: '.group-alternate-sort',
                onStop: function () {
                    self.setGroupAlternateSort();
                }
            });

            if(_.size(groupAlternates) > 0) {
                new PJQ.inputs.AutocompleteInput({
                    el: this.$('.group-alternate-category'),
                    source: _.bind(function (req, res) {
                        if (_.size(req.term) === 0) {
                            return [];
                        }
                        res(_.filter(_.map(groupAlternates, function (alternate) {
                            return alternate.get('category')
                        }), function (category) {
                            if (_.size(category) > 0 && category.toLowerCase().indexOf(req.term.toLowerCase()) !== -1) {
                                return category;
                            }
                        }));
                    }, this)
                });
            }

            PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.group-alternate-default'), 2);
        }
    },
    renderGroupAlternate: function (alternate, hasProposals) {
        let data = {
            item: alternate,
            isEdit: this.options.isEdit,
            hasProposals: hasProposals
        };
        this.renderSubTemplate(true, this.options.subTemplates.alternate, this.$('.bid-form-group-alternates'), data, function (content) {
            if (alternate.get('isNew'))
                content.find('.group-alternate-description').focus();
        });
    },
    setGroupAlternateSort: function () {
        let self = this;
        this.$('.group-alternate-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.model.alternates.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    groupAlternateChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-alternate-row'),
            cid = row.data('cid'),
            description = row.find('.group-alternate-description').val(),
            category = row.find('.group-alternate-category').val(),
            type = row.find('.group-alternate-type').val(),
            defaultValue = parseInt(PJQ.helpers.formatHelpers.numbersOnly(row.find('.group-alternate-default').val())),
            isRequired = row.find('.group-alternate-required').prop('checked'),
            isReadOnly = row.find('.group-alternate-readonly').prop('checked'),
            model = this.model.alternates.get({cid: cid});

        model.set({
            description: description,
            category: category,
            defaultValue: defaultValue,
            isRequired: isRequired,
            isReadOnly: isReadOnly,
        });
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderGroupAlternates();
        }
    },
    deleteGroupAlternate: function (e) {
        let cid = $(e.currentTarget).closest('.group-alternate-row').data('cid');
        this.model.updateAlternateDeleted(cid, true);
        $(e.currentTarget).closest('.group-alternate-row').remove();
    },
    newGroupAcknowledgement: function () {
        if (this.model)
            this.model.set('isChanged', true);
        let newAcknowledgement = new PJQ.models.bidForms.Acknowledgement({
            bidFormId: this.model.id,
            isNew: true,
            sortOrder: _.size(this.model.acknowledgements) + 1
        });
        this.model.acknowledgements.add(newAcknowledgement);
        this.model.set('acknowledgements', this.model.acknowledgements);
        this.renderGroupAcknowledgement(newAcknowledgement);
    },
    renderGroupAcknowledgements: function () {
        let hasProposals = this.model.bidders.getProposals(this.model.id).length > 0,
            groupAcknowledgements = this.model.acknowledgements.models,
            $gak = this.$('.bid-form-group-acknowledgements'),
            self = this;
        $gak.empty();
        _.each(_.sortBy(groupAcknowledgements, function (groupAcknowledgement) {
            return groupAcknowledgement.get('sortOrder');
        }), function (groupAcknowledgement) {
            self.renderGroupAcknowledgement(groupAcknowledgement, hasProposals);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gak, {
                items: '.group-acknowledgement-row',
                connectWith: '.group-acknowledgement-row',
                multiple: true,
                handle: '.group-acknowledgement-sort',
                onStop: function () {
                    self.setGroupAcknowledgementSort();
                }
            });
        }
    },
    renderGroupAcknowledgement: function (acknowledgement, hasProposals) {
        let data = {
            item: acknowledgement,
            isEdit: this.options.isEdit,
            acknowledgementTypes: PJQ.helpers.bidForms.acknowledgementTypes,
            hasProposals: hasProposals
        };
        this.renderSubTemplate(true, this.options.subTemplates.groupAcknowledgement, this.$('.bid-form-group-acknowledgements'), data, function (content) {
            if (acknowledgement.get('isNew'))
                content.find('.group-acknowledgement-description').focus();
        });
    },
    setGroupAcknowledgementSort: function () {
        let self = this;
        this.$('.group-acknowledgement-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.model.acknowledgements.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    groupAcknowledgementChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-acknowledgement-row'),
            cid = row.data('cid'),
            description = row.find('.group-acknowledgement-description').val(),
            category = row.find('.group-acknowledgement-category').val(),
            type = row.find('.group-acknowledgement-type').val(),
            isRequired = row.find('.group-acknowledgement-required').prop('checked'),
            model = this.model.acknowledgements.get({cid: cid});

        model.set('description', description);
        model.set('category', category);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderGroupAcknowledgements();
        }
        model.set('isRequired', isRequired);
    },
    deleteGroupAcknowledgement: function (e) {
        let cid = $(e.currentTarget).closest('.group-acknowledgement-row').data('cid');
        this.model.updateAcknowledgementDeleted(cid, true);
        $(e.currentTarget).closest('.group-acknowledgement-row').remove();
    },
    addGroupAcknowledgementChoices: function (e) {
        let cid = $(e.currentTarget).closest('.group-acknowledgement-row').data('cid'),
            model = this.model.acknowledgements.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectAcknowledgement: function () {
        this.projectBidForm.set('isChanged', true);
        let newAcknowledgement = new PJQ.models.bidForms.Acknowledgement({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.acknowledgements) + 1
        });
        this.projectBidForm.acknowledgements.add(newAcknowledgement);
        this.projectBidForm.set('acknowledgements', this.projectBidForm.acknowledgements);
        this.renderProjectAcknowledgement(newAcknowledgement);
    },
    renderProjectAcknowledgements: function () {
        let projectAcknowledgements = this.projectBidForm.acknowledgements.models,
            $gak = this.$('.bid-form-project-acknowledgements'),
            self = this;
        $gak.empty();
        _.each(_.sortBy(projectAcknowledgements, function (projectAcknowledgement) {
            return projectAcknowledgement.get('sortOrder');
        }), function (projectAcknowledgement) {
            self.renderProjectAcknowledgement(projectAcknowledgement);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gak, {
                items: '.project-acknowledgement-row',
                connectWith: '.project-acknowledgement-row',
                multiple: true,
                handle: '.project-acknowledgement-sort',
                onStop: function () {
                    self.setProjectAcknowledgementSort();
                }
            });
        }
    },
    renderProjectAcknowledgement: function (acknowledgement) {
        let data = {
            item: acknowledgement,
            isEdit: this.options.isEdit,
            acknowledgementTypes: PJQ.helpers.bidForms.acknowledgementTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.projectAcknowledgement, this.$('.bid-form-project-acknowledgements'), data, function (content) {
            if (acknowledgement.get('isNew'))
                content.find('.project-acknowledgement-description').focus();
        });
    },
    setProjectAcknowledgementSort: function () {
        let self = this;
        this.$('.project-acknowledgement-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.acknowledgements.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectAcknowledgementChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-acknowledgement-row'),
            cid = row.data('cid'),
            description = row.find('.project-acknowledgement-description').val(),
            category = row.find('.project-acknowledgement-category').val(),
            type = row.find('.project-acknowledgement-type').val(),
            isRequired = row.find('.project-acknowledgement-required').prop('checked'),
            model = this.projectBidForm.acknowledgements.get({cid: cid});

        model.set('description', description);
        model.set('category', category);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectAcknowledgements();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectAcknowledgement: function (e) {
        let cid = $(e.currentTarget).closest('.project-acknowledgement-row').data('cid');
        this.projectBidForm.updateAcknowledgementDeleted(cid, true);
        $(e.currentTarget).closest('.project-acknowledgement-row').remove();
    },
    addProjectAcknowledgementChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-acknowledgement-row').data('cid'),
            model = this.projectBidForm.acknowledgements.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectBonding: function () {
        this.projectBidForm.set('isChanged', true);
        let newBonding = new PJQ.models.bidForms.Bonding({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.bonding) + 1
        })
        this.projectBidForm.bonding.add(newBonding);
        this.projectBidForm.set('bonding', this.projectBidForm.bonding);
        this.renderProjectBonding(newBonding);
    },
    renderProjectBondings: function () {
        let projectBonding = this.projectBidForm.bonding.models,
            $gak = this.$('.bid-form-project-bonding'),
            self = this;
        $gak.empty();
        _.each(_.sortBy(projectBonding, function (bond) {
            return bond.get('sortOrder');
        }), function (bond) {
            self.renderProjectBonding(bond);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gak, {
                items: '.project-bonding-row',
                connectWith: '.project-bonding-row',
                multiple: true,
                handle: '.project-bonding-sort',
                onStop: function () {
                    self.setProjectBondingSort();
                }
            });
        }
    },
    renderProjectBonding: function (bonding) {
        let data = {
            item: bonding,
            isEdit: this.options.isEdit,
            bondingTypes: PJQ.helpers.bidForms.bondingTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.bonding, this.$('.bid-form-project-bonding'), data, function (content) {
            if (bonding.get('isNew'))
                content.find('.project-bonding-description').focus();
        });
    },
    setProjectBondingSort: function () {
        let self = this;
        this.$('.project-bonding-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.bonding.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectBondingChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-bonding-row'),
            cid = row.data('cid'),
            description = row.find('.project-bonding-description').val(),
            type = row.find('.project-bonding-type').val(),
            isRequired = row.find('.project-bonding-required').prop('checked'),
            model = this.projectBidForm.bonding.get({cid: cid});

        model.set('description', description);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectBondings();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectBonding: function (e) {
        let cid = $(e.currentTarget).closest('.project-bonding-row').data('cid');
        this.projectBidForm.updateBondingDeleted(cid, true);
        $(e.currentTarget).closest('.project-bonding-row').remove();
    },
    addProjectBondingChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-bonding-row').data('cid'),
            model = this.projectBidForm.bonding.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectCertification: function () {
        this.projectBidForm.set('isChanged', true);
        let newCertification = new PJQ.models.bidForms.Certification({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.certifications) + 1
        });
        this.projectBidForm.certifications.add(newCertification);
        this.projectBidForm.set('certifications', this.projectBidForm.certifications);
        this.renderProjectCertification(newCertification);
    },
    renderProjectCertifications: function () {
        let projectCertifications = this.projectBidForm.certifications.models,
            $gac = this.$('.bid-form-project-certifications'),
            self = this;
        $gac.empty();
        _.each(_.sortBy(projectCertifications, function (certification) {
            return certification.get('sortOrder');
        }), function (certification) {
            self.renderProjectCertification(certification);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gac, {
                items: '.project-certification-row',
                connectWith: '.project-certification-row',
                multiple: true,
                handle: '.project-certification-sort',
                onStop: function () {
                    self.setProjectCertificationSort();
                }
            });
        }
    },
    renderProjectCertification: function (certification) {
        let data = {
            item: certification,
            isEdit: this.options.isEdit,
            certificationTypes: PJQ.helpers.bidForms.certificationTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.certification, this.$('.bid-form-project-certifications'), data, function (content) {
            if (certification.get('isNew'))
                content.find('.project-certification-description').focus();
        });
    },
    setProjectCertificationSort: function () {
        let self = this;
        this.$('.project-certification-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.certifications.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectCertificationChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-certification-row'),
            cid = row.data('cid'),
            description = row.find('.project-certification-description').val(),
            type = row.find('.project-certification-type').val(),
            isRequired = row.find('.project-certification-required').prop('checked'),
            model = this.projectBidForm.certifications.get({cid: cid});

        model.set('description', description);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectCertifications();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectCertification: function (e) {
        let cid = $(e.currentTarget).closest('.project-certification-row').data('cid');
        this.projectBidForm.updateCertificationDeleted(cid, true);
        $(e.currentTarget).closest('.project-certification-row').remove();
    },
    addProjectCertificationChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-certification-row').data('cid'),
            model = this.projectBidForm.certifications.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    newProjectLaborRate: function () {
        this.projectBidForm.set('isChanged', true);
        let newLaborRate = new PJQ.models.bidForms.LaborRate({
            bidFormId: this.projectBidForm.id,
            isNew: true,
            sortOrder: _.size(this.projectBidForm.laborRates) + 1
        });
        this.projectBidForm.laborRates.add(newLaborRate);
        this.projectBidForm.set('laborRates', this.projectBidForm.laborRates);
        this.renderProjectLaborRate(newLaborRate);
    },
    renderProjectLaborRates: function () {
        let projectLaborRates = this.projectBidForm.laborRates.models,
            $gal = this.$('.bid-form-project-labor-rates'),
            self = this;
        $gal.empty();
        _.each(_.sortBy(projectLaborRates, function (laborRate) {
            return laborRate.get('sortOrder');
        }), function (laborRate) {
            self.renderProjectLaborRate(laborRate);
        });
        if (this.options.isEdit) {
            new PJQ.Sortable($gal, {
                items: '.project-labor-rate-row',
                connectWith: '.project-labor-rate-row',
                multiple: true,
                handle: '.project-labor-rate-sort',
                onStop: function () {
                    self.setProjectLaborRateSort();
                }
            });
        }
    },
    renderProjectLaborRate: function (laborRate) {
        let data = {
            item: laborRate,
            isEdit: this.options.isEdit,
            laborRateTypes: PJQ.helpers.bidForms.laborRateTypes
        };
        this.renderSubTemplate(true, this.options.subTemplates.laborRate, this.$('.bid-form-project-labor-rates'), data, function (content) {
            if (laborRate.get('isNew'))
                content.find('.project-labor-rate-description').focus();
        });
    },
    setProjectLaborRateSort: function () {
        let self = this;
        this.$('.project-labor-rate-row').each(function (index) {
            let cid = $(this).data('cid'),
                model = self.projectBidForm.laborRates.get({cid: cid});
            model.set('sortOrder', index + 1);
        });
    },
    projectLaborRateChanged: function (e) {
        let row = $(e.currentTarget).closest('.project-labor-rate-row'),
            cid = row.data('cid'),
            description = row.find('.project-labor-rate-description').val(),
            type = row.find('.project-labor-rate-type').val(),
            isRequired = row.find('.project-labor-rate-required').prop('checked'),
            model = this.projectBidForm.laborRates.get({cid: cid});

        model.set('description', description);
        if (model.get('type') !== type) {
            model.set('type', type);
            this.renderProjectLaborRates();
        }
        model.set('isRequired', isRequired);
    },
    deleteProjectLaborRate: function (e) {
        let cid = $(e.currentTarget).closest('.project-labor-rate-row').data('cid');
        this.projectBidForm.updateLaborRateDeleted(cid, true);
        $(e.currentTarget).closest('.project-labor-rate-row').remove();
    },
    addProjectLaborRateChoices: function (e) {
        let cid = $(e.currentTarget).closest('.project-labor-rate-row').data('cid'),
            model = this.projectBidForm.laborRates.get({cid: cid});

        new PJQ.views.customFields.CustomFieldChoicesEditor({
            collection: model.choices,
            isHideSearch: true,
            onSave: _.bind(function (choices) {
                model.set('choices', choices.models);
            }, this)
        });
    },
    enableEdit: function () {
        this.options.isEdit = true;
        this.render();
    },
    cancelEdit: function () {
        this.options.isEdit = false;
        this.projectBidForm.fetch();
        if (this.model)
            this.model.fetch();
        this.render();
    },
    saveBidForm: function () {
        this.options.isEdit = false;
        this.projectBidForm.save();
        if (this.model) {
            let loader = new PJQ.Loader(this.$el);
            this.model.save(null, {
                success: _.bind(function () {
                    loader.remove();
                    this.render();
                    PJQ.notifications.notify.successNotify({
                        message: 'Bid form saved'
                    });
                }, this),
                error: function () {
                    loader.remove();
                    PJQ.notifications.notify.errorNotify({
                        message: 'Failed to save bid form'
                    });
                }
            });
        }
    }
});

PJQ.views.bidForms.BidFormPreviewModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Preview'),
        isEdit: false,
        minWidth: 1000
    },
    events: {
        'click .select-version': 'selectVersion',
        'click .btn-view-drawing': 'viewDrawing',
        'click .btn-download-drawings': 'downloadDrawings'
    },
    beforeModalCreated: function () {
        this.options.canEdit = PJQ.app.session.project.hasPermission('bidForms.isAdmin');
        this.render();
    },
    renderData: function () {
        return {
            model: this.overrideProposal != null ? this.overrideProposal : this.model,
            canEdit: this.options.canEdit && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
        };
    },
    afterRender: function () {
        let proposal = this.overrideProposal != null ? this.overrideProposal : this.model;
        new PJQ.views.bidForms.BidFormViewer({
            el: this.$('.bid-form-viewer'),
            model: proposal,
            modal: this,
            collection: this.collection,
            settings: this.options.settings,
            projectBidForm: this.options.projectBidForm != null ? this.options.projectBidForm : this.model.projectProposal,
            isEdit: this.options.isEdit,
            onEditChange: _.bind(function (isEdit) {
                if (isEdit)
                    this.$('.modal-footer').hide();
                else
                    this.$('.modal-footer').show();
            }, this)
        });
        if (this.model instanceof PJQ.models.bidForms.Proposal) {
            this.renderStatus();
            this.listenTo(this.model, 'change sync', this.renderStatus);
        }
    },
    viewDrawing: function (e) {
        let drawingId = parseInt($(e.currentTarget).data('drawingId')),
            version = null,
            drawing = null;
        _.each(this.versions.models, function (ver) {
            _.each(ver.drawings.models, function (dr) {
                if ((drawing == null || ver.id === -1) && dr.id === drawingId) {
                    version = ver;
                    drawing = dr;
                }
            }, this);
        }, this);
        if (version != null && drawing != null) {
            new PJQ.views.drawings.DrawingViewer({
                model: drawing,
                contextVersion: version,
                versions: this.versions
            });
        }
    },
    downloadDrawings: function () {

    },
    renderStatus: function () {
        if (this.model instanceof PJQ.models.bidForms.Proposal) {
            let statusContainer = this.$('.proposal-status');
            statusContainer.html(this.model.getStatusName());
            statusContainer.parent().css('background-color', this.model.getStatusColor());
        }
    },
    selectVersion: function (e) {
        let proposalId = $(e.currentTarget).data('proposalId');
        if (this.model.id === proposalId) {
            this.overrideProposal = null;
            this.render();
        } else if (this.overrideProposal == null || this.overrideProposal.id !== proposalId) {
            this.overrideProposal = new PJQ.models.bidForms.Proposal({
                proposalId: proposalId
            });
            this.overrideProposal.fetch({
                success: _.bind(function () {
                    this.overrideProposal.bidder = this.model.bidder;
                    this.render();
                }, this)
            });
        }
    }
});

PJQ.views.bidForms.SealedBidContactsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Sealed-Bid-Contacts'),
        isEdit: false,
        projectContacts: null,
        selectedProjectContacts: null,
        onSealBids: _.noop,
        minWidth: 600
    },
    events: {
        'click .btn-seal': 'sealBids'
    },
    renderData: function () {
        return {
            isEdit: this.options.isEdit
        };
    },
    afterRender: function() {
        this.selectedContacts = null;
        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.sealed-bid-contacts'),
            contacts: this.options.projectContacts,
            selectedContact: this.options.selectedProjectContacts ? this.options.selectedProjectContacts.models : [],
            isSingleChoice: false,
            disableContacts: true,
            isReadOnly: !this.options.isEdit,
            onChange: _.bind(function (selectedContacts) {
                this.selectedContacts = selectedContacts;
                this.$('.btn-seal').prop('disabled', (_.size(selectedContacts) == 0));
            }, this)
        });

    },
    sealBids: function() {
        new PJQ.views.modals.YesNo({
            header: "Seal Bids",
            body: "Please Note: Only the selected contacts can unseal bids once you continue.  Are you sure you want to seal bids?",
            onYes: _.bind(function () {
                this.options.onSealBids(this.selectedContacts);
                this.removeModal();
            }, this)
        });
    }
});

PJQ.views.bidPackages.CopyBidFormModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Copy-From-Bidform'),
        maxWidth: '40%',
        onCopy: _.noop()
    },
    events: {
        'click .copy-bidform': 'copyBidForm'
    },
    beforeModalCreated: function() {
        if (this.options.isBidPackage) {
            this.options.otherBidForms = _.sortBy(this.options.otherBidForms, function (model) {
                return model.get('bidPackage').name;
            })
        } else {
            this.options.otherBidForms = _.sortBy(this.options.otherBidForms, function (model) {
                return model.get('group').groupName;
            })
        }
        this.render();
    },
    renderData: function () {
        return {
            isBidPackage: this.options.isBidPackage,
            otherBidForms: this.options.otherBidForms
        };
    },
    afterRender: function () {
        this.bidFormPicker = new PJQ.inputs.Selectpicker({
            el: $('.bidform-select'),
            isMultiple: false,
            isIntChoices: false,
            defaultValue: this.options.otherBidForms[0].cid
        });

        this.$('.copy-line-items,.copy-alternates,.copy-acknowledgements').on('change', _.bind(function() {
            this.$('.copy-bidform').prop('disabled', !this.$('.copy-line-items').prop('checked') && !this.$('.copy-alternates').prop('checked') && !this.$('.copy-acknowledgements').prop('checked'));
        }, this));
    },
    copyBidForm: function() {
        let selectedBidForm = null;
        _.each(this.options.otherBidForms, _.bind(function(bidForm) {
            if (bidForm.cid === this.bidFormPicker.getValue())
                selectedBidForm = bidForm;
        }, this));

        selectedBidForm.fetch({
            success: _.bind(function (data) {
                let copyLineItems = this.$('.copy-line-items').prop('checked'),
                    copyAlternates = this.$('.copy-alternates').prop('checked'),
                    copyAcknowledgements = this.$('.copy-acknowledgements').prop('checked'),
                    itemCount = 0;

                if (copyLineItems)
                    itemCount += _.size(selectedBidForm.get('lineItems'));

                if (copyAlternates)
                    itemCount += _.size(selectedBidForm.get('alternates'));

                if (copyAcknowledgements)
                    itemCount += _.size(selectedBidForm.get('acknowledgements'));

                if (itemCount === 0) {
                    new PJQ.views.BaseModal({
                        header: "Unable to Copy",
                        body: "The selected " + (this.options.isBidPackage ? 'Bid Package' : 'Trade' ) + " does not contain any data matching your selected options."
                    });
                    return;
                }

                this.options.onCopy(selectedBidForm, copyLineItems, copyAlternates, copyAcknowledgements);

                this.removeModal();
            }, this)
        });
    }
});

//Models
PJQ.models.bidForms.Proposal = PJQ.models.bidForms.GroupBidForm.extend({
    idAttribute: "proposalId",
    afterInit: function () {
        this.on('change:isSubmitted', function () {
            if (this.bidder && this.bidder.collection)
                this.bidder.collection.trigger('change');
        });
    },
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'proposals',
                    value: this.id
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'bidForms',
                    value: this.get('bidFormId')
                },
                {
                    endpoint: 'proposals'
                }
            ])
        }
    },
    beforeConstruct: function (attributes) {
        this.lineItems = new PJQ.collections.bidForms.ProposalLineItems([], {bidFormId: attributes.bidFormId });
        this.alternates = new PJQ.collections.bidForms.Alternates([], {bidFormId: attributes.bidFormId});
        this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
        this.attachments = new PJQ.collections.bidForms.Attachments([], {bidFormId: attributes.bidFormId});
        this.projectProposal = new PJQ.models.bidForms.ProjectProposal({});
        this.submittedBy = new PJQ.models.bidForms.Bidder({});
        if (attributes.managedBy) {
            this.managedBy = new PJQ.models.contacts.Contact(attributes.managedBy);
        } else {
            this.managedBy = null;
        }
    },
    parse: function (proposal) {
        if (proposal.bidPackage != null) {
            this.bidPackage = new PJQ.models.bidPackages.BidPackage(proposal.bidPackage);
        } else {
            this.bidPackage = null;
        }

        if (proposal.lineItems) {
            this.lineItems.reset(proposal.lineItems);

            _.each(this.lineItems.models, function (lineItem) {
                lineItem.comments = new PJQ.collections.bidForms.ProposalLineItemComments(lineItem.get('comments'), { lineItem: lineItem });
            });
        }

        if (proposal.alternates) {
            this.alternates.reset(proposal.alternates);

            _.each(this.alternates.models, function (alternate) {
                alternate.comments = new PJQ.collections.bidForms.ProposalAlternateComments(alternate.get('comments'), { alternate: alternate });
            });
        }

        if (_.size(proposal.acknowledgements) > 0) {
            this.acknowledgements.reset(proposal.acknowledgements);
        }

        if (proposal.bidPackageId > 0 && proposal.bidPackage) {
            this.bidPackage = new PJQ.models.bidPackages.BidPackage(proposal.bidPackage)
        }

        this.attachments.reset(proposal.attachments);
        this.projectProposal.parse(proposal.projectProposal);
        if (proposal.submittedBy != null) {
            this.submittedBy = new PJQ.models.bidForms.Bidder(proposal.submittedBy);
        }
        if (proposal.managedBy) {
            this.managedBy = new PJQ.models.contacts.Contact(proposal.managedBy);
        } else {
            this.managedBy = null;
        }

        return proposal;
    },
    preview: function (collection, opts) {
        if (!opts)
            opts = {};
        opts.model = this;
        opts.collection = collection;
        opts.projectBidForm = this.projectProposal;
        new PJQ.views.bidForms.BidFormPreviewModal(opts);
    },
    getStatusName: function () {
        let notSubNamePref = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.BID_FORM_NOT_SUBMITTED_STATUS_NAME_OVERRIDE);
        let status;
        if (notSubNamePref != null) {
            status = notSubNamePref;
        } else {
            status = 'Not Submitted';
        }
        if (this.get('isAwarded'))
            status = 'Awarded';
        else if (this.get('isRejected'))
            status = 'Rejected';
        else if (this.get('isSubmitted'))
            status = 'Submitted';
        return status;
    },
    getStatusId: function () {
        let status = 0;
        if (this.get('isAwarded'))
            status = 3;
        else if (this.get('isRejected'))
            status = 4;
        else if (this.get('isSubmitted'))
            status = 2;
        return status;
    },
    getStatusColor: function () {
        switch (this.getStatusId()) {
            case 4:
                return '#dc3545';
            case 2:
                return '#2196F3';
            case 3:
                return '#4CAF50';
            case 0:
            default:
                return '#9E9E9E';
        }
    },
    export: function (isExportLeveling, isExportComments) {
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.id
            },
            {
                endpoint: 'exportproposal'
            }
        ],[
            {
                parameter: 'leveling',
                value: isExportLeveling
            },
            {
                parameter: 'comments',
                value: isExportComments
            }
        ]));
    },
    updateAttachmentDeleted: function (cid, isDeleted) {
        let attachment = this.attachments.get({cid: cid});
        if (attachment.id == null)
            this.attachments.remove(attachment);
        else
            attachment.set('isDeleted', isDeleted);
    },
    setLocked: function () {
        this.set('isLocked', !this.get('isLocked'));
        this.save();
    },
    reject: function (note) {
        this.set({
            isRejected: true,
            rejectNote: _.size(note) > 0 ? note : null
        });
        this.save();
    },
    updateViewed: function (callback) {
        if (this.get('viewedOn') == null && this.get('submittedOn') != null) {
            new PJQ.ajax.Request({
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'proposals',
                        value: this.id
                    },
                    {
                        endpoint: 'viewed'
                    }
                ])
            }).get().done(_.bind(function (data) {
                this.set('viewedOn', data.viewedOn);
                if (typeof callback === 'function') {
                    callback(data.viewedOn);
                }
            }, this)).fail(function () {
            });
        } else {
            if (typeof callback === 'function') {
                callback(null);
            }
        }
    },
    submit: function (isSubmit, callback) {
        this.set({
            isSubmitted: isSubmit,
            rejectNote: null
        })
        _.each(this.bidder.contacts.models, function (contact) {
            contact.set('bidStatus', PJQ.constants.projectContacts.bidStatus.BID_RECEIVED);
        });
        if (this.bidder && this.bidder.collection)
            this.bidder.collection.trigger('change');
        this.save(null, {
            success: callback,
            error: function () {
                //todo: notify error
            }
        });
    },
    award: function (isAward) {
        this.set('isAwarded', isAward);
        _.each(this.bidder.contacts.models, function (contact) {
            contact.set('bidStatus', isAward ? PJQ.constants.projectContacts.bidStatus.AWARDED : PJQ.constants.projectContacts.bidStatus.BID_RECEIVED);
        });
        if (this.bidder && this.bidder.collection)
            this.bidder.collection.trigger('change');
        this.save();
    },
    beforeSave: function () {
        _.each(this.lineItems.models, function (lineItem) {
            lineItem.set('comments', lineItem.comments.models);
        });
        _.each(this.alternates.models, function (alternate) {
            alternate.set('comments', alternate.comments.models);
        });
        this.set('lineItems', this.lineItems.toJSON());
        this.set('alternates', this.alternates.toJSON());
        this.set('acknowledgements', this.acknowledgements.toJSON());
        this.set('attachments', this.attachments.toJSON());
        this.projectProposal.beforeSave();
        this.attributes.projectProposal = this.projectProposal.attributes;
    }
});

PJQ.models.bidForms.ProjectProposal = PJQ.models.bidForms.Proposal.extend({
    beforeConstruct: function (attributes) {
        this.acknowledgements = new PJQ.collections.bidForms.Acknowledgements([], {bidFormId: attributes.bidFormId});
        this.bonding = new PJQ.collections.bidForms.Bonding([], {bidFormId: attributes.bidFormId});
        this.certifications = new PJQ.collections.bidForms.Certifications([], {bidFormId: attributes.bidFormId});
        this.laborRates = new PJQ.collections.bidForms.LaborRates([], {bidFormId: attributes.bidFormId});
    },
    parse: function (proposal) {
        if (proposal) {
            if (_.size(proposal.acknowledgements) > 0) {
                this.acknowledgements.reset(proposal.acknowledgements);
            } else {
                proposal.acknowledgements = this.acknowledgements.toJSON();
            }
            if (_.size(proposal.bonding) > 0) {
                this.bonding.reset(proposal.bonding);
            } else {
                proposal.bonding = this.bonding.toJSON();
            }
            if (_.size(proposal.certifications) > 0) {
                this.certifications.reset(proposal.certifications);
            } else {
                proposal.certifications = this.certifications.toJSON();
            }
            if (_.size(proposal.laborRates) > 0) {
                this.laborRates.reset(proposal.laborRates);
            } else {
                proposal.laborRates = this.laborRates.toJSON();
            }
            this.attributes = _.defaults(proposal, this.attributes ? this.attributes : {});
        }
        return proposal;
    },
    beforeSave: function () {
        this.set('acknowledgements', this.acknowledgements.getChangedModels());
        this.set('bonding', this.bonding.getChangedModels());
        this.set('certifications', this.certifications.getChangedModels());
        this.set('laborRates', this.laborRates.getChangedModels());
    }
});

PJQ.models.bidForms.Attachment = PJQ.models.files.File.extend({
    idAttribute: "proposalAttachmentId"
});

PJQ.models.bidForms.ProposalLineItem = PJQ.models.bidForms.LineItem.extend({
    beforeConstruct: function (attributes) {
        this.comments = new PJQ.collections.bidForms.ProposalLineItemComments([], { lineItem: this });
    }
});

PJQ.models.bidForms.ProposalLineItemComment = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.get('proposalId')
            },
            {
                endpoint: 'lineitems',
                value: this.get('proposalLineItemId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ])
    },
    defaults: {
        comment: "",
        createdBy: 0,
        createdByDisplay: ""
    }
});

PJQ.models.bidForms.ProposalAlternateComment = PJQ.models.BaseModel.extend({
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.get('proposalId')
            },
            {
                endpoint: 'alternates',
                value: this.get('proposalAlternateId')
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ])
    },
    defaults: {
        comment: "",
        createdBy: 0,
        createdByDisplay: ""
    }
});

//Collections
PJQ.collections.bidForms.Proposals = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.Proposal,
    endpoint: function () {
        if (this.options.contactId && (!this.options.bidFormId)) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'contacts',
                    value: this.options.contactId
                },
                {
                    endpoint: 'proposals'
                }
            ]);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'bidforms',
                    value: this.options.bidFormId
                },
                {
                    endpoint: 'proposals'
                }
            ]);
        }
    },
    getLowestProposal: function (isIncludeAlternates) {
        let sortedProposals = _.sortBy(this.getSubmittedProposals(), function (model) {
            return model.calculateTotal(isIncludeAlternates)
        });
        return sortedProposals.length > 0 ? sortedProposals[0] : null;
    },
    getSubmittedProposals: function () {
        return _.filter(this.models, function (proposal) {
            return proposal.get('isSubmitted')
        });
    }
});

PJQ.collections.bidForms.Attachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.bidForms.Attachment
});


PJQ.collections.bidForms.ProposalLineItems = PJQ.collections.bidForms.LineItems.extend({
    model: PJQ.models.bidForms.ProposalLineItem
});

PJQ.collections.bidForms.ProposalLineItemComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.ProposalLineItemComment,
    endpoint: function(urlOptions) {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.options.lineItem.get('proposalId')
            },
            {
                endpoint: 'lineitems',
                value: this.options.lineItem.get('proposalLineItemId')
            },
            {
                endpoint: 'updatecomments'
            }
        ])
    }
});

PJQ.collections.bidForms.ProposalAlternateComments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.ProposalAlternateComment,
    endpoint: function(urlOptions) {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.options.alternate.get('proposalId')
            },
            {
                endpoint: 'alternates',
                value: this.options.alternate.get('proposalAlternateId')
            },
            {
                endpoint: 'updatecomments'
            }
        ])
    }
});
PJQ.views.bidForms.Proposals = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposals'),
        subTemplates: {
            proposalLeveling: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Leveling'),
            item: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Item'),
            itemTooltip: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Item-Tooltip')
        },
        canEdit: false,
        canSelect: false,
        isLeveling: false
    },
    events: {
        "click .open-bidders-tab": "openBiddersTab",
        'click .proposals-compare': 'compareProposals',
        "click .proposals-export-excel": "exportExcel",
        "click .proposals-export-selected": "exportSelected",
        "click .proposals-export-select": "selectProposals",
        "click .proposals-cancel-select": "cancelSelect",
        "click .cb-alternate-enabled": "alternateEnabled",
        "click .btn-view-proposal": "viewProposal",
        "click .btn-reject-proposal": "rejectProposal",
        "click .btn-revise-proposal": "reviseProposal",
        "click .btn-award-proposal": "awardProposal",
        "click .btn-export-proposal": "exportProposal",
        "click .btn-delete-proposal": "deleteProposal",
        'keyup .proposals-search': 'filterProposals',
        'click .proposals-clear-filters': 'clearFilters',
        'click .btn-enable-leveling': 'enableLeveling',
        'click .btn-cancel-leveling': 'cancelLeveling',
        'click .btn-save-leveling': 'saveLeveling',
        'mousedown .proposal-item': 'levelItem'
    },
    beforeFirstRender: function () {
        $('body').on('mousedown', _.bind(function () {
            if (this.options.isLeveling) {
                this.removeActiveLevelItem();
            }
        }, this));

        this.search = "";
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
        this.listenTo(this.collection, "sync change update reset", this.render);
    },
    renderData: function () {
        let proposals = []
        if (this.options.bidForm && this.options.bidForm.get('bidPackage') != null) {
            proposals = this.collection.getProposals(null);
        } else {
            proposals = this.collection.getProposals(this.options.bidForm.id);
        }
        _.each(proposals.models, function (proposal) {
            if (proposal.get('viewedOn') == null && proposal.get('submittedOn') != null) {
                proposal.updateViewed();
            }
        });

        return {
            canEdit: this.options.canEdit,
            canView: !this.options.settings.get('isSealBids') || this.options.settings.isSealedBidContact(PJQ.app.session.user.get('id')),
            collection: proposals,
            canSelect: this.options.canSelect,
            search: this.search,
            settings: this.options.settings
        };
    },
    afterRender: function () {
        this.statusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.proposals-status-filter'),
            onChange: _.bind(this.filterProposals, this),
            isMultiple: true,
            defaultValue: this.statusFilter,
            noneSelectedText: 'No Filters'
        });
        this.searchBar = this.$('.proposals-search');

        this.renderProposals();

        this.$('.proposals-container').sortable({
            items: '.bid-form-proposal',
            connectWith: '.bid-form-proposal',
            update: _.bind(function () {
                this.changeSort();
            }, this)
        });
    },
    changeSort: function () {
        let self = this,
            proposals = this.collection.getProposals(this.options.bidForm.id);
        this.$('.bid-form-proposal').each(function (index) {
            if (self.getSearchFilter().length === 0 && self.getStatusFilter().length === 0) {
                let proposal = proposals.get($(this).data('cid'));
                if (proposal) {
                    proposal.set('sortOrder', index + 1);
                    proposal.save();
                }
            }
        });
    },
    clearFilters: function () {
        this.statusFilterPicker.deselectAll();
        this.search = "";
        this.searchBar.val(this.search);
        this.filterProposals();
    },
    filterProposals: function () {
        this.statusFilter = this.statusFilterPicker.getValue();
        this.search = this.searchBar.val().trim();
        this.renderProposals();
    },
    selectProposals: function () {
        this.selectedIds = [];
        this.options.canSelect = true;
        this.exportToolbar = new PJQ.views.toolbars.ExportSelectedToolbar({
            el: this.$el,
            onExport: _.bind(function () {
                this.exportSelected();
                this.exportToolbar.destroy();
                this.cancelSelectProposals();
            }, this),
            onClose: _.bind(function () {
                this.cancelSelectProposals();
            }, this)
        });
        this.render();
    },
    cancelSelectProposals: function () {
        this.options.canSelect = false;
        this.render();
    },
    getFilteredProposals: function () {
        let proposals = [];
        if (this.options.bidForm && this.options.bidForm.get('bidPackage') != null) {
            proposals = this.collection.getProposals(null).models;
        } else {
            proposals = this.collection.getProposals(this.options.bidForm.id).models;
        }

        if (this.options.settings.get('isBidLevelingEnabled')) {
            /* 2024-09-18 Blue: are not filtering unsubmitted out of levelling mode at this time.
            proposals = _.filter(proposals, function (proposal) {
                return proposal.get('isSubmitted');
            });
            */
        }

        if (true) {
            let searchFilter = this.getSearchFilter().toLowerCase();
            if (searchFilter.length > 0) {
                proposals = _.filter(proposals, function (model) {
                    return null != _.find(model.bidder.contacts.models, function (contact) {
                        if (contact.get('email').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else if (contact.get('companyName').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else if (contact.get('contactName').toLowerCase().indexOf(searchFilter) !== -1)
                            return true;
                        else {
                            let numSearch = PJQ.helpers.formatHelpers.numbersOnly(searchFilter);
                            if (_.size(numSearch) === 0)
                                return false;
                            if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('phone')).indexOf(numSearch) !== -1)
                                return true;
                            else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('fax')).indexOf(numSearch) !== -1)
                                return true;
                            else if (PJQ.helpers.formatHelpers.numbersOnly(contact.get('cell')).indexOf(numSearch) !== -1)
                                return true;
                        }
                    });
                });
            }

            let statusF = this.getStatusFilter();
            if (statusF.length > 0) {
                proposals = _.filter(proposals, function (model) {
                    let result = false;
                    if (statusF.indexOf('submitted') !== -1 && model.get('isSubmitted')) {
                        result = true;
                    } else if (statusF.indexOf('notsubmitted') !== -1 && !model.get('isSubmitted') && !model.get('isRejected')) {
                        result = true;
                    } else if (statusF.indexOf('rejected') !== -1 && model.get('isRejected')) {
                        result = true;
                    }

                    if (statusF.indexOf('locked') !== -1 && model.get('isLocked')) {
                        result = true;
                    } else if (statusF.indexOf('locked') !== -1 && !model.get('isLocked')) {
                        result = false;
                    }

                    if (statusF.indexOf('unlocked') !== -1 && !model.get('isLocked')) {
                        result = true;
                    } else if (statusF.indexOf('unlocked') !== -1 && model.get('isLocked')) {
                        result = false;
                    }

                    return result;
                }, this);
            }
        }

        return new PJQ.collections.bidForms.Proposals(proposals)
    },
    makeProposalItemTooltip: function ($item) {
        if ($item.hasClass('leveled')) {
            new PJQ.Tooltip($item, {
                template: this.options.subTemplates.itemTooltip,
                container: this.$el,
                trigger: 'hover',
                renderData: _.bind(function () {
                    return {
                        cost: parseInt($item.data('cost')),
                        leveledCost: parseInt($item.data('leveledCost')),
                        multiplier: parseInt($item.data('multiplier')),
                        leveledMultiplier: parseInt($item.data('leveledMultiplier')),
                        notes: $item.data('notes')
                    };
                }, this)
            });
        }
    },
    makeProposalItem: function (proposalItem) {
        let itemClass,
            isAlternate = false;
        if (proposalItem instanceof PJQ.models.bidForms.Alternate) {
            itemClass = 'proposal-alternate';
            isAlternate = true;
        } else if (proposalItem instanceof PJQ.models.bidForms.LineItem) {
            itemClass = 'proposal-line-item';
        } else {
            return $('<div></div>');
        }

        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.item, {
            isQuestion: PJQ.helpers.bidForms.lineItemQuestionTypes.indexOf(proposalItem.get('type')) !== -1,
            itemClass: itemClass,
            isAlternate: isAlternate,
            proposalItem: proposalItem
        });
    },
    enableLeveling: function () {
        this.options.isLeveling = true;
        this.renderProposals();
    },
    cancelLeveling: function () {
        this.options.isLeveling = false;
        this.renderProposals();
    },
    saveLeveling: function () {
        this.options.isLeveling = false;

        _.each(this.leveledProposals, function (prop) {

        });

        this.renderProposals();
    },
    saveActiveLevelItem: function () {
        let $active = this.$('.level-proposal-item');
        if ($active.length > 0) {
            let leveledCost = parseInt(PJQ.helpers.formatHelpers.numbersOnly($active.find('.item-cost').val())),
                $multiplier = $active.find('.item-multiplier'),
                leveledMultiplier = null;
            if ($multiplier.length > 0) {
                leveledMultiplier = parseInt(PJQ.helpers.formatHelpers.numbersOnly($active.find('.item-cost').val()));
            }

            if (this.contextLevelItem.get('cost') === leveledCost && (leveledMultiplier == null || this.contextLevelItem.get('multiplier') === leveledMultiplier)) {
                leveledMultiplier = null;
                leveledCost = null;
            }

            this.contextLevelItem.set({
                leveledCost: leveledCost,
                leveledMultiplier: leveledMultiplier
            });

            let notes = $active.find('.item-notes').val();
            this.contextLevelItem.set('notes', _.size(notes.trim()) > 0 ? notes : '');

            if (this.contextLevelItem.hasChanged() && null == _.findWhere(this.leveledProposals, function (prop) {
                return prop.id === this.contextProposal.id;
            }, this)) {
                this.leveledProposals.push(this.leveledProposals);
            }

            let $item = $active.closest('.proposal-item'),
                $proposal = $item.closest('.proposal-card'),
                proposalId = $proposal.data('proposalId'),
                proposal = this.proposals.get(proposalId);
            $proposal.find('.proposal-sub-total').text(PJQ.helpers.formatHelpers.formatCurrency(proposal.calculateTotal()));
            $proposal.find('.proposal-leveled-total').text(PJQ.helpers.formatHelpers.formatCurrency(proposal.calculateTotal(true)));

            let $newItem = this.makeProposalItem(this.contextLevelItem);
            $item.replaceWith($newItem);
            $item.find('.item-cost-d').text(PJQ.helpers.formatHelpers.formatCurrency(leveledCost));

            this.makeProposalItemTooltip($newItem.find('.proposal-item'));
        }
    },
    removeActiveLevelItem: function () {
        this.saveActiveLevelItem();
        this.$('.level-proposal-item').remove();
        this.contextProposal = null;
        this.contextLevelItem = null;
    },
    levelItem: function (e) {
        e.stopPropagation();

        if (!this.options.isLeveling) {
            return;
        }

        let $target = $(e.currentTarget),
            itemCid = $target.data('cid');
        if (this.contextLevelItem == null || itemCid !== this.contextLevelItem.cid) {
            this.removeActiveLevelItem();

            let proposalId = $target.closest('.proposal-card').data('proposalId');
            this.contextProposal = this.proposals.get(proposalId);
            if ($target.hasClass('proposal-line-item')) {
                this.contextLevelItem = this.contextProposal.lineItems.get(itemCid);
            } else if ($target.hasClass('proposal-alternate')) {
                this.contextLevelItem = this.contextProposal.alternates.get(itemCid);
            } else {
                return;
            }

            let $out = $('<div class="level-proposal-item top-0 left-0 right-0 ht-100p position-absolute elevation-1 rounded bg-white"></div>');
            if (this.contextLevelItem.get('type').toLowerCase() === "sum") {
                let cost = this.contextLevelItem.get('leveledCost') ? this.contextLevelItem.get('leveledCost') : this.contextLevelItem.get('cost');
                $out.append('<div class="text-align-right mr-4 wd-100 border-bottom border-muted pb-2"><input type="text" class="input-text mt-2 item-cost text-align-right" value="' + PJQ.helpers.formatHelpers.formatCurrency(cost, 2, false) + '" /></div>');

                let $cost = $out.find('.item-cost');
                PJQ.helpers.inputHelpers.inputMaskCurrency($cost, 2);
                $cost.focus();
            } else {

            }
            $out.append('<textarea class="item-notes p-1 wd-100" placeholder="Notes...">' + (this.contextLevelItem.get('notes') ? this.contextLevelItem.get('notes') : '') + '</textarea>');
            $target.append($out);
        }
    },
    alternateEnabled: function (e) {
        let $target = $(e.currentTarget),
            alternateId = $target.data('alternateId'),
            isEnabled = $target.prop('checked');
        _.each(this.proposals.models, function (proposal) {
            let propAlternate = proposal.alternates.findWhere({bidFormAlternateId: alternateId});
            if (propAlternate != null) {
                propAlternate.set('isLevel', isEnabled);
            }
        });
        let bfAlternate = this.options.bidForm.alternates.get(alternateId);
        bfAlternate.set('isLevel', isEnabled);
        this.renderProposals();
    },
    viewProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.preview(this.collection, {
            isEdit: false
        });
    },
    rejectProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        new PJQ.views.bidForms.RejectModal({
            onConfirm: _.bind(function (note) {
                selectedProp.reject(note);
                this.render();
            }, this)
        });
    },
    reviseProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.preview(this.collection, {
            isEdit: true
        });
    },
    awardProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        _.each(this.collection.models, function (proposal) {
            proposal.set({
                awardedOn: null,
                awardedBy: null,
                isAwarded: false
            });
        });
        selectedProp.award(true);
    },
    exportProposal: function (e) {
        /*
        Export already being handled by PJQ.views.bidForms.Proposal - if this is needed, then need to deconflict.

        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        selectedProp.export();
         */
    },
    deleteProposal: function (e) {
        let proposalId = $(e.currentTarget).closest('.proposal-card').data('proposalId'),
            selectedProp = this.proposals.get(proposalId);
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this proposal?  This will delete all versions of the proposal.",
            onDelete: _.bind(function () {
                selectedProp.destroy();
                this.collection.trigger('change');
            }, this)
        });
    },
    renderProposals: function () {
        this.leveledProposals = [];
        this.contextProposal = null;
        this.contextLevelItem = null;

        this.proposals = this.getFilteredProposals();
        if (this.options.settings.get('isBidLevelingEnabled')) {
            this.renderSubTemplate(false, this.options.subTemplates.proposalLeveling, this.$('.proposals-inner'), {
                makeProposalItem: _.bind(this.makeProposalItem, this),
                proposals: this.proposals,
                bidForm: this.options.bidForm,
                settings: this.options.settings,
                isLeveling: this.options.isLeveling
            });
        } else {
            this.$('.proposals-inner').empty();

            let $row = $('<div class="row"></div>');
            this.$('.proposals-inner').append($row);
            _.each(_.sortBy(this.proposals.models, function (model) {
                return model.get('sortOrder');
            }), function (model) {
                //don't render unsubmitted proposals to select from
                if (this.options.canSelect && !model.get('isSubmitted')) {
                    return;
                }

                let container = $('<div class="col-4 bid-form-proposal" data-cid="' + model.cid + '" />');
                $row.append(container);
                new PJQ.views.bidForms.Proposal({
                    model: model,
                    project: this.options.project,
                    collection: this.collection,
                    el: container,
                    settings: this.options.settings,
                    canSelect: this.options.canSelect,
                    isSelected: this.selectedIds != null && this.selectedIds.indexOf(model.id) !== -1,
                    onSelect: _.bind(function (isSelected) {
                        if (isSelected) {
                            this.selectedIds = _.union([model.id], this.selectedIds);
                        } else {
                            this.selectedIds = _.without(this.selectedIds, model.id);
                        }
                        this.exportToolbar.updateSelectedCount(_.size(this.selectedIds));
                    }, this)
                });
            }, this);
        }

        if (PJQ.app.options.initProposal != null && !PJQ.app.options.initProposal.get('isShown')) {
            let matchInitProposal = this.collection.getProposals().get(PJQ.app.options.initProposal.id);
            if (matchInitProposal == null) {
                // unable to find initProposal by id, check revisions
                matchInitProposal = _.find(this.collection.getProposals().models, function (prop) {
                    return _.size(prop.get('revisions')) > 0
                        && null != _.find(prop.get('revisions'), function (rev) {
                            return rev.proposalId === PJQ.app.options.initProposal.id;
                        });
                });
            }

            if (matchInitProposal != null) {
                matchInitProposal.preview(this.collection, {
                    isEdit: false
                });
                PJQ.app.options.initProposal = null;
            }
        }

        let self = this;
        this.$('.proposal-item.leveled').each(function () {
            self.makeProposalItemTooltip($(this));
        });
    },
    getStatusFilter: function () {
        return this.statusFilter ? this.statusFilter : [];
    },
    getSearchFilter: function () {
        return this.search ? this.search : "";
    },
    openBiddersTab: function () {
        $('a[href="#biddersContainer"]').tab('show');
    },
    compareProposals: function () {
        new PJQ.views.bidForms.ProposalsCompareModal({
            collection: this.collection.getProposals(this.options.bidForm.id),
            settings: this.options.settings
        });
    },
    exportSelected: function () {
        this.exportProposals(this.selectedIds);
        /*
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'bidforms',
                value: this.options.bidForm.id
            },
            {
                endpoint: 'export'
            }
        ], [
            {
                parameter: "ids",
                value: this.selectedIds
            }
        ]));
         */
    },
    exportExcel: function () {
        this.exportProposals(null);
        /*
        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'bidforms',
                value: this.options.bidForm.id
            },
            {
                endpoint: 'export'
            }
        ]));
         */
    },
    exportProposals: function(proposalIds) {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false,
            fnExport = _.bind(function(proposalIds, exportLeveledProposal, exportComments) {
                PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'bidforms',
                        value: this.options.bidForm.id
                    },
                    {
                        endpoint: 'export'
                    }
                ], [
                    {
                        parameter: 'leveling',
                        value: exportLeveledProposal
                    },
                    {
                        parameter: 'comments',
                        value: exportComments
                    },
                    {
                        parameter: "ids",
                        value: proposalIds
                    }
                ]));
        }, this);

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: _.bind(function(exportLeveledProposal, exportComments) {
                    fnExport(proposalIds, exportLeveledProposal, exportComments);
                }, this)
            });
        }
        else {
            fnExport(proposalIds, false, false);
        }

    }
});

PJQ.views.bidForms.Proposal = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal'),
        subTemplates: {
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input')
        },
        canSelect: false,
        onSelect: null,
        isSelected: false
    },
    events: {
        "click .proposal-review-button": "reviewProposal",
        "click .proposal-edit-button": "editProposal",
        "click .btn-export-proposal": "exportProposal",
        "change .cb-proposal": "selectProposal",
        "click .btn-line-item-comments": "viewComments",
        "click .btn-alternate-comments": "viewComments"
    },
    beforeFirstRender: function () {
        this.options.canEdit = this.options.project != null ? this.options.project.hasPermission('bidForms.isAdmin') : true;
        this.model.on("sync", this.render, this);
    },
    renderData: function () {
        let isLowestProposal = false,
            isLowestProposalWithAlternates = false,
            lowestProposal = this.collection.getLowestProposal(this.model.get('bidFormId'), false),
            lowestProposalWithAlternates = this.collection.getLowestProposal(this.model.get('bidFormId'), true);

        if (lowestProposal && lowestProposal.id === this.model.id)
            isLowestProposal = true;
        if (lowestProposalWithAlternates && lowestProposalWithAlternates.id === this.model.id)
            isLowestProposalWithAlternates = true;
        return {
            proposal: this.model,
            canEdit: this.options.canEdit,
            isLowestProposal: isLowestProposal,
            isLowestProposalWithAlts: isLowestProposalWithAlternates,
            helpers: PJQ.helpers,
            settings: this.options.settings,
            canSelect: this.options.canSelect,
            isSelected: this.options.isSelected,
            getItemInput: _.bind(this.getItemInput, this),
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            canAddComments: PJQ.app.session.project.hasPermission('bidForms.canAddComments')
        };
    },
    afterRender: function () {
        this.$('.proposals-container').sortable({
            items: '.bid-form-proposal',
            connectWith: '.bid-form-proposal'
        });

    },
    reviewProposal: function () {
        this.model.preview(this.collection, {
            isEdit: false
        });
    },
    editProposal: function () {
        this.model.preview(this.collection, {
            isEdit: true
        });
    },
    exportProposal: function () {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: _.bind(function(exportLeveledProposal, exportComments) {
                    this.model.export(exportLeveledProposal, exportComments);
                }, this)
            });
        }
        else {
            this.model.export(false, false);
        }
    },
    selectProposal: function () {
        if (typeof this.options.onSelect === 'function') {
            this.options.onSelect(this.$('.cb-proposal').prop('checked'));
        }
    },
    getItemInput: function (model) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: false,
            helpers: PJQ.helpers
        });
    },
    viewComments: function(event) {
        let el = $(event.currentTarget).parent(),
            cid = $(event.currentTarget).data('cid'),
            isLineItem = $(event.currentTarget).hasClass('btn-line-item-comments'),
            item = isLineItem ? this.model.lineItems.get(cid) : this.model.alternates.get(cid);

        new PJQ.views.bidForms.ProposalItemEditModal({
            item: item,
            onSave: _.bind(function() {
                var comments = _.filter(item.comments.models, function (comment) {
                        return !comment.get('isDeleted');
                    }),
                    $commentButton = el.find('.btn-line-item-comments'),
                    $commentButtonIcon = el.find('.btn-line-item-comments i'),
                    tooltip = 'No';

                if (comments.length > 0) {
                    tooltip = comments.length.toString();

                    $commentButton.removeClass('btn-transparent-dark').addClass('btn-light');
                    $commentButtonIcon.removeClass('text-muted').addClass('text-dark');
                }
                else {
                    $commentButton.removeClass('btn-light').addClass('btn-transparent-dark');
                    $commentButtonIcon.removeClass('text-dark').addClass('text-muted');
                }

                tooltip = tooltip + ' Comment' + (comments.length!=1 ? 's':'');
                $commentButton.attr('title', tooltip);

                // if we're not in edit mode, we have to manually save changes to the comments.
                if (!this.options.isEdit && _.some(item.comments.models, function(model) {
                    return (!model.get('proposalLineItemCommentId') && isLineItem) || (!model.get('proposalAlternateCommentId') && !isLineItem)  || model.get('isDeleted');
                })) {
                    item.comments.save({
                        success: _.bind(function (data) {
                            item.comments.reset(data);
                            PJQ.notifications.notify.successNotify({
                                message: 'Comments updated successfully'
                            });
                        }, this),
                        error: _.bind(function () {
                            PJQ.notifications.notify.errorNotify({
                                message: 'Comment update failed'
                            });
                        }, this)
                    });
                }
            }, this)
        });

    }
});

PJQ.views.bidForms.ProposalsCompareModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Proposals-Compare'),
        compareProposals: []
    },
    events: {
        "click .proposal-compare": "compareProposalClick"
    },
    renderData: function () {
        return {
            lowestProposal: this.collection.getLowestProposal(false),
            lowestProposalWithAlternates: this.collection.getLowestProposal(true),
            helpers: PJQ.helpers,
            collection: this.collection,
            settings: this.options.settings,
            compareProposals: this.getCompareProposals()
        };
    },
    afterRender: function () {
        new PJQ.views.bidForms.ProposalsCompare({
            el: this.$('.proposals-compare'),
            collection: this.getCompareProposals(),
            settings: this.options.settings
        });
    },
    getCompareProposals: function () {
        return new PJQ.collections.bidForms.Proposals(this.options.compareProposals);
    },
    compareProposalClick: function (e) {
        let cid = $(e.currentTarget).closest('.proposal-select').data('cid');
        this.compareProposal(this.collection.get({cid: cid}));
    },
    compareProposal: function (proposal) {
        if (_.findWhere(this.options.compareProposals, {cid: proposal.cid})) {
            this.options.compareProposals = _.filter(this.options.compareProposals, function (compareProposal) {
                return proposal.cid !== compareProposal.cid;
            })
        } else {
            this.options.compareProposals.push(proposal);
        }
        this.render();
    }
});

PJQ.views.bidForms.ProposalsCompare = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposals-Compare'),
        subTemplates: {
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input')
        }
    },
    events: {
        "click .proposal-edit-button": "editProposal"
    },
    renderData: function () {
        return {
            lowestProposal: this.collection.getLowestProposal(false),
            lowestProposalWithAlternates: this.collection.getLowestProposal(true),
            getItemInput: _.bind(this.getItemInput, this),
            helpers: PJQ.helpers,
            collection: this.collection,
            settings: this.options.settings
        };
    },
    reviewProposal: function () {
        this.model.preview(this.collection, {
            isEdit: false
        });
    },
    getItemInput: function (model) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: false,
            helpers: PJQ.helpers
        });
    }
});

PJQ.views.bidForms.RejectModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'modal-reject-proposal'),
        onConfirm: null
    },
    events: {
        'click .btn-confirm': 'confirm'
    },
    confirm: function () {
        let rejectNote = this.$(".reject-note").val();
        if (typeof this.options.onConfirm === 'function') {
            this.options.onConfirm(rejectNote);
        }
        this.removeModal();
    }
});

PJQ.views.bidForms.ExportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'modal-export-proposals'),
        isBidLevelingEnabled: false,
        canViewComments: false,
        onExport: null
    },
    events: {
        'click .btn-export': 'exportProposals'
    },
    beforeModalCreated: function () {
        this.exportLeveledProposal = false;
        this.exportComments = false;

    },
    beforeRender: function () {
        this.renderData = {
            isBidLevelingEnabled: this.options.isBidLevelingEnabled,
            canViewComments: this.options.canViewComments
        };
    },
    exportProposals: function () {
        this.exportComments = this.$('.input-export-comments').prop('checked');
        if (typeof this.options.onExport === 'function') {
            this.options.onExport(this.exportLeveledProposal, this.exportComments);
        }
        this.removeModal();
    }
});


//Models
PJQ.models.bidForms.Settings = PJQ.models.BaseModel.extend({
	idAttribute: 'settingId',
	endpoint: function () {
		if (this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'bidForms'
				},
				{
					endpoint: 'settings'
				}
			]);
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidForms'
			},
			{
				endpoint: 'settings'
			}
		]);
	},
	parse: function (model) {
		if (model) {
			if (model.additionalBidDocuments) {
				this.additionalBidDocuments = new PJQ.collections.files.Files(model.additionalBidDocuments);
			}
			else {
				this.additionalBidDocuments = new PJQ.collections.files.Files();
			}
		}
		else {
			this.additionalBidDocuments = new PJQ.collections.files.Files();
		}
		return model;
	},
	beforeSave: function () {
		this.set('additionalBidDocuments', this.additionalBidDocuments.getChangedModels());
	},
	isSealedBidContact: function(id) {
		return _.size(_.filter(this.get('sealedBidContactList'), function(contact) {
			return contact.id == id;
		})) > 0;
	}
});
PJQ.views.bidForms.Settings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Settings'),
		subTemplates: {},
		maxWidth: 500,
		overrideLockDate: false,
		onChange: null,
		isDefaultSettings: null
	},
	events: {
		'click .cb-bid-leveling': 'bidLevelingChanged',
		'click .settings-save': 'onSave',
		'change .input-override-lock-date': 'overrideLockChanged',
		'change .cb-use-bid-packages': 'useBidPackagesChanged'
	},
	beforeFirstRender: function () {
		new PJQ.Loader(this.$('.modal-body'));
		if (this.model != null) {
			if (_.size(this.model.get('defaultLineItemDescription')) === 0)
				this.model.set('defaultLineItemDescription','Base Bid');

			this.fetchProjectCustomFields(_.bind(function () {
				this.render();
			}, this))
		}
		else {
			this.fetchSettings(_.bind(function () {
				this.fetchProjectCustomFields(_.bind(function () {
					this.render();
				}, this))
			}, this))
		}
	},
	fetchSettings: function (callback) {
		let fnCallback = _.bind(function (settings) {
			this.model = settings;
			if (_.size(this.model.get('defaultLineItemDescription')) === 0)
				this.model.set('defaultLineItemDescription','Base Bid');

			if (typeof callback === 'function') {
				callback();
			}
		}, this);
		if (this.options.project != null) {
			this.options.project.fetchBidFormSettings(fnCallback);
		}
		else {
			PJQ.app.session.fetchBidFormSettings(fnCallback);
		}
	},
	fetchProjectCustomFields: function (callback) {
		let fnCallback = _.bind(function (customFields) {
			this.options.dateCustomFields = customFields.filter(function (customField) {
				return customField.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATE
					|| customField.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATETIME;
			});
			if (typeof callback === 'function') {
				callback();
			}
		}, this);
		if (this.options.project != null) {
			this.options.project.fetchProjectCustomFields(fnCallback);
		}
		else {
			PJQ.app.session.fetchProjectCustomFields(null, fnCallback);
		}
	},
	renderData: function () {
		return {
			model: this.model,
			dateCustomFields: this.options.dateCustomFields,
			overrideLockDate: this.options.overrideLockDate
		};
	},
	overrideLockChanged: function () {
		this.options.overrideLockDate = !this.options.overrideLockDate;
		this.render();
	},
	useBidPackagesChanged: function () {
		let $cbUseBidPackages = this.$('.cb-use-bid-packages'),
			useBidPackages = $cbUseBidPackages.prop('checked'),
			fnAfterChange = _.bind(function() {
				if (useBidPackages) {
					this.model.set('isAddDefaultLineItem', false);
					this.$('.cb-add-default-lineitem').prop('checked', false).prop('disabled', true);
				}
				else {
					// enable auto line items control
					this.$('.cb-add-default-lineitem').prop('disabled', false);
				}

				this.render();
			}, this);

		if (this.options.project != null) {
			let confirmHeader,
				confirmBody;
			if (useBidPackages) {
				confirmHeader = "Switch to Bid Packages Bid Forms?";
				confirmBody = "Enabling Bid Package Bid Forms will remove any <b>Trade Bid Forms and related Proposals</b> currently on this project.  This will also move related Line Items, Alternates, and Acknowledgements to the new corresponding Bid Package Bid Form if existing. Are you sure you would like to switch to using Bid Package Bid Forms?";
			}
			else {
				confirmHeader = "Switch to Trade Bid Forms?";
				confirmBody = "Disabling Bid Package Bid Forms will switch this project to Trade Bid Forms and remove all <b>Bid Package Proposals</b> currently on this project. Are you sure you would like to switch to using Trade Bid Forms?";
			}
			new PJQ.views.modals.YesNo({
				header: confirmHeader,
				body: confirmBody,
				onYes: _.bind(function() {
					fnAfterChange();
				}, this),
				onNo: _.bind(function () {
					useBidPackages = !useBidPackages;
					this.model.set('isUsingBidPackages', useBidPackages);
					$cbUseBidPackages.prop('checked', useBidPackages);
					fnAfterChange();
				}, this)
			});
		} else {
			fnAfterChange();
		}

	},
	bidLevelingChanged: function () {
		if (this.options.project != null && this.$('.cb-bid-leveling').prop('checked')) {
			let confirmBody = "Are you sure you want to enable bid leveling?<br /><strong>Note:</strong> ";
			if (this.options.project != null) {
				confirmBody += "Enabling bid leveling on this project will prevent bidders from creating their own line items and alternates.  Any submitted bid on this project with line items or alternates created by the bidder will be marked as rejected.";
			}
			else {
				confirmBody += "Enabling bid leveling system-wide will prevent bidders from creating their own line items and alternates.  This will not enable bid leveling on projects that already contain submitted bids with line items or alternates created by the bidder.";
			}
			new PJQ.views.modals.YesNo({
				header: "Enable Bid Leveling?",
				body: confirmBody,
				onNo: _.bind(function () {
					this.model.set('isBidLevelingEnabled', false);
					this.$('.cb-bid-leveling').prop('checked', false);
				}, this)
			});
		}
	},
	onChange: function () {
		if (this.model.get('isAddDefaultLineItem') && _.size(this.model.get('defaultLineItemDescription')) ==0) {
			this.model.set('defaultLineItemDescription','Base Bid');
		}

		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	},
	/*
	validateSettings: function() {
		let result = true;
		if (this.model.get('isAddDefaultLineItem')) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.input-description'), true);

			result = _.size(this.model.get('defaultLineItemDescription')) > 0;

			if (!result)
				PJQ.helpers.inputHelpers.setInputError(this.$('.input-description'));
		}

		return result;
	},
	 */
	afterRender: function () {
		if (this.model && this.model.isFetched) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				],
				afterChange: _.bind(function (changeEl, attribute) {
					if (attribute === 'isAllowLateBids' || attribute === 'isAddDefaultLineItem') {
						this.render();
					}
					if (attribute === 'isAutoExportProposals') {
						if (!this.model.get('isAutoExportProposals'))
							this.model.set('isExportProposalsByTrade', false);

						this.render();
					}
					if (attribute === 'isExportProposalsByTrade') {
						if (this.model.get('isExportProposalsByTrade'))
							this.model.set('isAutoExportProposals', true);

						this.render();
					}
					this.onChange();
				}, this)
			});

			if (this.options.isDefaultSettings) {
				this.$('.bid-form-settings-header').text('Default Bid Form Settings');
				this.$('.bid-form-settings-info').removeClass('hidden');
			}

			if (this.options.overrideLockDate) {
				new PJQ.inputs.Datepicker({
					el: this.$('.input-lock-date'),
					isShowTimezone: false,
					datepickerOptions: {
						defaultDate: this.model.get('lockDate') != null ? new Date(this.model.get('lockDate')) : null
					},
					onChange: _.bind(function () {
						this.onChange();
					}, this)
				});
			}
			else {
				let cf = this.model.get('lockDateCustomField');
				new PJQ.inputs.Selectpicker({
					el: this.$('.select-lock-source'),
					defaultValue: cf != null ? ('cf_' + cf.toString()) : 'BIDS_DUE',
					onChange: _.bind(function (value) {
						this.model.set('lockDateCustomField', value === 'BIDS_DUE' ? null : parseInt(value.replace('cf_', '')));

						this.onChange();
					}, this)
				});
			}

			new PJQ.views.files.FileUploaderGrid({
				el: this.$('.bid-documents-file-upload'),
				collection: this.model.additionalBidDocuments,
				onDrop: _.bind(function () {
					this.onChange();
				}, this),
				onDelete: _.bind(function (file, callback) {
					file.set('isDeleted', true);
					callback();

					this.onChange();
				}, this)
			});
		}
	}
});

PJQ.views.bidForms.BidFormSettingsModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Bid-Form-Settings'),
		minWidth: "600px",
	},
	events: {
		'click .settings-save': 'onSave'
	},
	afterRender: function () {
		this.settingsView = new PJQ.views.bidForms.Settings({
			el: this.$('.modal-body'),
			model: this.model,
			project: this.options.project
		});
	},
	onSave: function () {
		/* We can't reliably call this from the global Settings.
		if (!this.settingsView.validateSettings())
			return;

		 */

		//We have to be sure we save te project and the daily report settings before we callback to onSave
		//The onSave is likely waiting to get a new list of reports to refresh their statuses
		let loader = new PJQ.Loader(this.$('.modal-content'));
		this.settingsView.model.save(null, {
			success: _.bind(function () {
				PJQ.notifications.notify.successNotify({
					message: 'Bid forms settings saved'
				});
				if (typeof this.options.onSave === 'function') {
					this.options.onSave();
				}
				this.removeModal();
			}, this),
			error: function () {
				loader.remove();
			}
		});
	}
});
PJQ.views.bidForms.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
	beforeFirstRender: function () {
		this.collection = new PJQ.collections.bidForms.Templates();
		this.listenTo(this.collection, 'fetch', this.render);
		this.collection.fetch();
	},
	addTemplate: function () {
		new PJQ.views.templates.NewTemplateModal({
			model: new PJQ.models.bidForms.Template(),
			onSave: _.bind(function (template) {
				this.collection.add(template);
				this.editTemplate(template);
			}, this)
		});
	},
	editTemplate: function (template) {
		new PJQ.views.bidForms.EditTemplateModal({
			model: template,
			onClose: _.bind(function () {
				this.dataTable.refresh();
			}, this),
			onDelete: _.bind(function (template) {
				if (template.id > 0) {
					let row = this.dataTable.getRow(template.cid);
					this.collection.remove(template);
					template.destroy();
					this.dataTable.removeRow(row);
				}
			}, this)
		});
	}
});

PJQ.views.bidForms.SaveAsTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Save-As-Template'),
		maxWidth: 500
	},
	events: {
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		this.model = new PJQ.models.bidForms.Template({
			projectId: this.options.project.id
		});

		PJQ.app.session.fetchBidFormTemplates(_.bind(function (tmp) {
			this.templates = tmp;
			this.render();
		}, this));
	},
	renderData: function () {
		return {
			templates: this.templates
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			new PJQ.inputs.AutocompleteInput({
				el: this.$('.input-template-name'),
				source: _.map(this.templates.models, function (template) {
					return template.get('name')
				})
			});
		}
	},
	save: function () {
		let $name = this.$('.input-template-name'),
			name = $name.val();
		if (_.size(name.trim()) === 0) {
			PJQ.helpers.inputHelpers.setInputError($name);
			return;
		}
		else {
			PJQ.helpers.inputHelpers.setInputError($name, true);
		}

		let existingTemplate = this.templates.findWhere({name: name}),
			fnSave = _.bind(function () {
				this.model.save({
					name: name,
					groupIds: null
				}, {
					success: _.bind(function () {
						this.removeModal();
						PJQ.notifications.notify.successNotify({
							message: 'Bid Form Template Created'
						});
					}, this)
				});
			}, this);
		if (existingTemplate != null) {
			new PJQ.views.modals.YesNo({
				header: "Overwrite Template",
				body: "A template already exists with this name.  Would you like to overwrite it?",
				onYes: _.bind(function () {
					this.model.set('templateId', existingTemplate.id);
					fnSave();
				}, this)
			});
		}
		else {
			fnSave();
		}
	}
});

PJQ.views.bidForms.ImportTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Import-Template'),
		maxWidth: 500,
		onImport: null
	},
	events: {
		'change .input-select-groups': 'filterGroups',
		'click .btn-import': 'save'
	},
	beforeModalCreated: function () {
		PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
			this.settings = settings;
			PJQ.app.session.fetchBidFormTemplates(_.bind(function (tmp) {
				this.templates = tmp;
				this.render();
			}, this));
		}, this))
	},
	renderData: function () {
		return {
			templates: this.templates != null && this.templates.isFetched ? _.filter(this.templates.models, _.bind(function (template) {
				return !this.settings.get('isUsingBidPackages') || template.get('bidPackageTemplateId') > 0;
			}, this)) : null,
			selectedTemplate: this.selectedTemplate
		};
	},
	afterRender: function () {
		if (this.templates != null && this.templates.isFetched) {
			this.templatePicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-template'),
				defaultValue: this.selectedTemplate ? this.selectedTemplate.id : null,
				onChange: _.bind(function (value) {
					this.selectedTemplate = this.templates.get(value);
					this.render();
				}, this),
				isIntChoices: true,
				noneSelectedText: 'Select Template'
			});

			if (this.selectedTemplate != null && !(this.selectedTemplate.get('bidPackageTemplateId') > 0)) {
				this.groupSelector = new PJQ.views.groups.GroupSelector({
					el: this.$('.group-selector')
				});
			}
		}
	},
	filterGroups: function () {
		let $sel = this.$('.group-selector');
		if (this.$('.input-select-groups').prop('checked')) {
			$sel.removeClass('hidden');
		}
		else {
			$sel.addClass('hidden');
		}
	},
	save: function () {
		let isValid = true;
		if (this.selectedTemplate == null) {
			this.templatePicker.showError();
			isValid = false;
		}
		else {
			this.templatePicker.hideError();
		}

		let selectedGroups = [];
		if (this.$('.input-select-groups').prop('checked')) {
			selectedGroups = this.groupSelector.getGroupsData().selected;
			if (_.size(selectedGroups) === 0) {
				this.groupSelector.showError("Select at least 1 group");
				isValid = false;
			}
			else {
				this.groupSelector.hideError();
			}
		}

		if (!isValid) {
			return;
		}

		this.settings.set('isUsingBidPackages', this.selectedTemplate.get('bidPackageTemplateId') > 0);

		if(this.settings.hasChanged()){
			this.settings.save(null, {
				success: _.bind(function() {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'projects',
								value: this.options.project.id
							},
							{
								endpoint: 'bidforms'
							},
							{
								endpoint: 'import',
								value: this.selectedTemplate.id
							}
						], [
							{
								parameter: 'overwrite',
								value: this.$('.input-overwrite').prop('checked')
							},
							{
								parameter: 'importProjectBidForm',
								value: this.$('.input-project-bid-form').prop('checked')
							}
						]),
						data: {
							ids: _.map(selectedGroups, function (group) {
								return group.id;
							})
						}
					}).put().done(_.bind(function (response) {
						if (typeof this.options.onImport === 'function') {
							let result = new PJQ.models.schedule.Schedule(response);
							result.isFetched = true;
							this.options.onImport(result, this.settings);
						}
						this.removeModal();
						PJQ.notifications.notify.successNotify({
							message: 'Bid Form Template Imported'
						});
					}, this));
				}, this)
			});
		}
		else{
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: this.options.project.id
					},
					{
						endpoint: 'bidforms'
					},
					{
						endpoint: 'import',
						value: this.selectedTemplate.id
					}
				], [
					{
						parameter: 'overwrite',
						value: this.$('.input-overwrite').prop('checked')
					},
					{
						parameter: 'importProjectBidForm',
						value: this.$('.input-project-bid-form').prop('checked')
					}
				]),
				data: {
					ids: _.map(selectedGroups, function (group) {
						return group.id;
					})
				}
			}).put().done(_.bind(function (response) {
				if (typeof this.options.onImport === 'function') {
					let result = new PJQ.models.schedule.Schedule(response);
					result.isFetched = true;
					this.options.onImport(result, this.settings);
				}
				this.removeModal();
				PJQ.notifications.notify.successNotify({
					message: 'Bid Form Template Imported'
				});
			}, this));
		}
	}
});

PJQ.views.bidForms.EditTemplateModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Edit-Template'),
		maxWidth: '90%',
		onClose: null
	},
	events: {
		'click .btn-close': 'close',
		'click .btn-delete': 'deleteTemplate'
	},
	beforeModalCreated: function () {
		this.listenTo(this.model, 'fetch', this.render);
		PJQ.app.session.fetchBidPackageTemplates(_.bind(function (templates) {
			this.bidPackageTemplates = templates;
			this.model.fetch();
		}, this));
	},
	renderData: function () {
		return {
			model: this.model
		};
	},
	afterRender: function () {
		if (this.model.isFetched) {
			new PJQ.inputs.TextEditorInput({
				el: this.$('.edit-template-name'),
				label: 'Name',
				value: this.model.get('name'),
				onSave: _.bind(function (value) {
					this.model.patch({
						name: value
					});
				}, this)
			});

			new PJQ.inputs.SelectPickerEditorInput({
				el: this.$('.edit-template-bid-package'),
				label: 'Bid Package Template',
				selectPickerOptions: {
					choices: _.map(this.bidPackageTemplates.models, function (template) {
						return {
							id: template.id,
							name: template.get('name')
						}
					}),
					isIntChoices: true
				},
				value: this.model.get('bidPackageTemplateId'),
				onSave: _.bind(function (value) {
					let fnSetPackage = _.bind(function () {
						this.model.patch({
							bidPackageTemplateId: value
						}, {
							success: _.bind(function (bidFormTemplate) {
								if (this.bidFormEditor) {
									this.bidFormEditor.collection = null;
									this.bidFormEditor.options.bidFormTemplate = bidFormTemplate;
									this.bidFormEditor.render();
								}
							}, this)
						});
					}, this)
					if (this.model.get('bidPackageTemplateId') == null) {
						new PJQ.views.modals.YesNo({
							header: "Assign Bid Package Template",
							body: "Are you sure you want to assign a Bid Package Template?  This action will remove all Trade Bid Forms from this Bid Form Template.  All existing line items, alternates, and acknowledgements will be moved to the corresponding Bid Package Bid Form if one exists.",
							onYes: _.bind(function () {
								fnSetPackage();
							}, this),
							onNo: _.bind(function () {
								if (this.bidFormEditor) {
									this.bidFormEditor.render();
								}
							}, this)
						});
					}
					else {
						fnSetPackage();
					}
				}, this)
			});

			this.bidFormEditor = new PJQ.views.bidForms.BidFormEditorSelector({
				el: this.$('.manage-template'),
				bidFormTemplate: this.model
			});
		}
	},
	close: function () {
		if (typeof this.options.onClose === 'function') {
			this.options.onClose(this.model);
		}
	},
	deleteTemplate: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this template?",
			onDelete: _.bind(function () {
				if (typeof this.options.onDelete === 'function') {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});

PJQ.views.bidForms.BidFormViewer = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-BidForm'),
        subTemplates: {
            lineItem: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Group-LineItem'),
            alternate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Group-Alternate'),
            groupAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Group-Acknowledgement'),
            projectAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Acknowledgement'),
            bonding: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Bonding'),
            certification: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Certification'),
            laborRate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Labor-Rate'),
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input'),
            bidder: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bidder')
        },
        isEdit: true,
        onEditChange: _.noop
    },
    events: {
        "click .add-group-line-item-button": "newGroupLineItem",
        "click .add-group-alternate-button": "newGroupAlternate",
        "change .group-line-item-type": "groupLineItemChanged",
        "keyup .group-line-item-description,.group-line-item-cost-dollars,.group-line-item-cost-cents,.group-line-item-multiplier": "groupLineItemChanged",
        "click .delete-group-line-item-button": "deleteGroupLineItem",
        "change .group-alternate-type": "groupAlternateChanged",
        "keyup .group-alternate-description,.group-alternate-cost-dollars,.group-alternate-cost-cents,.group-alternate-multiplier": "groupAlternateChanged",
        "click .delete-group-alternate-button": "deleteGroupAlternate",
        "keydown .bid-form-item-numeric": "numbersOnly",
        "keydown .bid-form-item-numeric-negative": "numbersOnlyNegative",
        "keydown .line-item-multiplier,.alternate-multiplier": "numbersAndSingleDecimalOnly",
        "keyup .bid-form-inclusions": "inclusionsChanged",
        "keyup .bid-form-exclusions": "exclusionsChanged",
        "click .bid-form-attachment-download": "downloadAttachment",
        "click .bid-form-additional-document-download": "downloadAdditionalBidDocument",
        "keyup .bid-form-notes": "notesChanged",
        "click .bid-form-lock": "setLocked",
        "click .bid-form-reject": "reject",
        "click .bid-form-submit": "submit",
        "click .bid-form-award": "award",
        "click .bid-form-unaward": "unaward",
        "click .bid-form-save": "save",
        "click .bid-form-edit": "edit",
        "click .proposal-export-all": "exportProposalWithAttachments",
        "click .proposal-export-proposal": "exportProposal",
        "click .proposal-export-attachments": "exportAttachments",
        "click .bid-form-compare": "compare",
        "click .bid-form-cancel-edit": "cancelEdit",
        'click .bidder-edit': 'editBidder',
    },
    beforeFirstRender: function () {
        this.options.canEdit = PJQ.app.session.project.hasPermission('bidForms.isAdmin') || PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');
        this.options.isAdmin = PJQ.app.session.user != null && PJQ.app.session.project.hasPermission('bidForms.isAdmin') && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId');

        if (this.options.projectBidForm) {
            this.projectBidForm = this.options.projectBidForm;
            this.listenTo(this.projectBidForm, "sync", this.render);
            this.listenTo(this.projectBidForm, "change", this.changed);
            this.listenTo(this.projectBidForm.acknowledgements, "change", this.changed);
            this.listenTo(this.projectBidForm.bonding, "change", this.changed);
            this.listenTo(this.projectBidForm.certifications, "change", this.changed);
            this.listenTo(this.projectBidForm.laborRates, "change", this.changed);
        }

        if (this.model) {
            this.listenTo(this.model, "sync", this.render);
            this.listenTo(this.model, "change", this.changed);
            this.listenTo(this.model.lineItems, "change", this.changed);
            this.listenTo(this.model.alternates, "change", this.changed);
            this.listenTo(this.model.acknowledgements, "change", this.changed);
        }

        if (this.options.settings == null) {
            PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
                this.options.settings = settings;
                this.render();
            }, this));
        }
    },
    beforeRender: function () {
        this.options.isEdit = this.options.isEdit && !this.model.get('isLocked');
        this.options.onEditChange(this.options.isEdit);
        if (this.model != null && this.model instanceof PJQ.models.bidForms.Proposal) {
            let dialogDeleteButton = this.$el.closest('.modal-content').find('.proposal-delete');
            if (dialogDeleteButton != null) {
                dialogDeleteButton.off().on('click', _.bind(function () {
                    this.deleteProposal();
                }, this))
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            isShowErrors: this.options.isShowErrors,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            projectBidForm: this.projectBidForm,
            settings: this.options.settings,
            collection: this.collection,
            proposals: this.collection != null ? this.collection.getProposals(this.model.get('bidFormId')) : [],
            isEdit: this.options.isEdit,
            requireAttachments: !this.options.isAdmin && this.options.settings.get('isRequireAttachment')
        };
    },
    afterRender: function () {
        if (this.options.settings == null) {
            return;
        }

        if (this.options.isAdmin) {
            this.renderBidderInfo();
        }

        this.renderGroupLineItems();

        this.renderGroupAlternates();

        this.renderAdditionalBidDocuments();

        _.each(_.sortBy(this.model.acknowledgements.models, function (ack) {
            return ack.get('sortOrder');
        }), _.bind(function (acknowledgement) {
            this.renderGroupAcknowledgement(acknowledgement);
        }, this));

        _.each(_.sortBy(this.projectBidForm.acknowledgements.models, function (bond) {
            return bond.get('sortOrder');
        }), _.bind(function (acknowledgement) {
            this.renderProjectAcknowledgement(acknowledgement);
        }, this));

        _.each(this.projectBidForm.bonding.models, _.bind(function (bonding) {
            this.renderProjectBonding(bonding);
        }, this));

        _.each(_.sortBy(this.projectBidForm.certifications.models, function (cert) {
            return cert.get('sortOrder');
        }), _.bind(function (certification) {
            this.renderProjectCertification(certification);
        }, this));

        _.each(_.sortBy(this.projectBidForm.laborRates.models, function (labor) {
            return labor.get('sortOrder');
        }), _.bind(function (laborRate) {
            this.renderProjectLaborRate(laborRate);
        }, this));

        if (this.options.isEdit) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.bid-form-file-upload'),
                collection: this.model.attachments,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'proposals',
                        value: this.model.get('proposalId')
                    },
                    {
                        endpoint: 'attachments'
                    }
                ]),
                onDrop: _.bind(function () {
                    this.changed();
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    this.changed();
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });

            if (this.options.hasFileError) {
                this.fileUploader.showError("You must attach all requested bid documents before submitting.", null);
            }
        }

        this.options.isShowErrors = false;
    },
    renderAdditionalBidDocuments: function () {

    },
    renderBidderInfo: function () {
        if (this.options.isAdmin && this.model.bidder != null) {
            this.renderSubTemplate(false, this.options.subTemplates.bidder, this.$el.closest('.modal-content').find('.bid-form-bidder-info'), {
                bidder: this.model.bidder,
                canEdit: this.options.canEdit,
                colClass: 'col-lg-6 col-sm-12',
                isShowDelete: false,
                isShowBidStatus: false
            });
        }
    },
    editBidder: function (e) {
        let selectedContact = this.model.bidder.contacts.get($(e.currentTarget).closest('.bidder-contact-container').data('cid'));
        new PJQ.views.contacts.BaseEditContactModal({
            model: selectedContact,
            onSave: _.bind(function () {
                this.model.bidder.set('companyName', selectedContact.get('companyName'));
                this.renderBidderInfo();
            }, this)
        });
    },
    getItemInput: function (model, isEdit) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: isEdit,
            helpers: PJQ.helpers
        });
    },
    changed: function () {
        this.$('.bid-form-save').prop('disabled', false);
    },
    newGroupLineItem: function () {
        let newLineItem = new PJQ.models.bidForms.LineItem({
                bidFormId: this.model.id,
                isNew: true
            }),
            currentLineItems = this.model.lineItems;
        newLineItem.set('comments', []);
        newLineItem.comments = new PJQ.collections.bidForms.ProposalLineItemComments();
        currentLineItems.add(newLineItem);
        this.model.set('lineItems', currentLineItems);
        this.renderGroupLineItems();
    },
    renderGroupLineItems: function () {
        this.$('.bid-form-group-line-items').empty();
        _.each(_.sortBy(_.sortBy(this.model.lineItems.models, function (lineItem) {
            return lineItem.get('sortOrder');
        }), function (lineItem) {
            return lineItem.get('contactCompanyId');
        }), _.bind(function (lineItem) {
            this.renderGroupLineItem(lineItem);
        }, this));
    },
    renderGroupLineItem: function (lineItem) {
        let category = lineItem.get('category'),
            $outer = this.$('.bid-form-group-line-items'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.line-item-category[data-category="' + category + '"]>.line-items');
            if ($container.length === 0) {
                let subtotal = 0;
                _.each(_.filter(this.model.lineItems.models, function (item) {
                    return item.get('category') === category
                }), function (item) {
                    subtotal += item.calculateTotal();
                });
                $outer.append('<div class="line-item-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="line-items ml-2"></div><div class="subtotal-outer ml-2 mb-2"></div></div>');

                let $category = $outer.find('.line-item-category[data-category="' + category + '"]');
                $container = $category.find('.line-items');

                let $subtotal = $category.find('.subtotal-outer');
                $subtotal.append('<div><div class="row border-top border-muted fs-16 pt-2"><div class="offset-7 col-2 text-align-right font-weight-medium">Subtotal:</div><div class="col-2 text-align-center no-padding-right subtotal">' + PJQ.helpers.formatHelpers.formatCurrency(subtotal) + '</div></div></div>');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: lineItem,
            isEdit: this.options.isEdit,
            subTotal: PJQ.helpers.formatHelpers.formatCurrency(lineItem.calculateTotal()),
            formatHelpers: PJQ.helpers.formatHelpers,
            getItemInput: _.bind(this.getItemInput, this),
            isError: this.options.isShowErrors && lineItem.get('isRequired') && (lineItem.get('cost') == null || (lineItem.get('type').toLowerCase() !== "sum" && lineItem.get('multiplier') == null)),
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments')
        };
        this.renderSubTemplate(true, this.options.subTemplates.lineItem, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, lineItem, _.bind(function (value) {
                this.updateBidFormItem(lineItem, value);
            }, this));
        }, this));
    },
    groupLineItemChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-line-item-row'),
            cid = row.data('cid'),
            costDollars = row.find('.group-line-item-cost-dollars').val(),
            costCents = row.find('.group-line-item-cost-cents').val(),
            multiplier = row.find('.group-line-item-multiplier').val(),
            descriptionInput = row.find('.group-line-item-description'),
            typeInput = row.find('.group-line-item-type'),
            model = this.model.lineItems.get({cid: cid});

        if (costDollars.length > 0 && costCents.length === 0) {
            costCents = '00';
        } else if (costDollars.length === 0 && costCents.length > 0) {
            costDollars = '0';
        }

        model.set({
            cost: costDollars.length === 0 && costCents.length === 0 ? null : PJQ.helpers.formatHelpers.getTotalCents(costDollars, costCents),
            multiplier: isNaN(multiplier) ? 0 : multiplier
        });

        this.calculateLineItemSubtotal(e);

        if (descriptionInput.length > 0 && typeInput.length > 0) {
            let type = typeInput.val();
            model.set('description', descriptionInput.val());
            if (model.get('type') !== type) {
                if (type.toLowerCase() === 'sum')
                    model.set('multiplier', 0);
                model.set('type', type);

                this.renderGroupLineItems();
            }
        }
    },
    deleteGroupLineItem: function (e) {
        let cid = $(e.currentTarget).closest('.group-line-item-row').data('cid');
        this.model.updateLineItemDeleted(cid, true);
        $(e.currentTarget).closest('.group-line-item-row').remove();
    },
    newGroupAlternate: function () {
        let newAlternate = new PJQ.models.bidForms.Alternate({
                bidFormId: this.model.id,
                isNew: true
            }),
            currentAlternates = this.model.alternates;
        newAlternate.set('comments', []);
        newAlternate.comments = new PJQ.collections.bidForms.ProposalAlternateComments();
        currentAlternates.add(newAlternate);
        this.model.set('alternates', currentAlternates);
        this.renderGroupAlternate(newAlternate);
    },
    renderGroupAlternates: function () {
        this.$('.bid-form-group-alternates').empty();
        _.each(_.sortBy(this.model.alternates.models, function (alternate) {
            return alternate.get('sortOrder');
        }), _.bind(function (alternate) {
            this.renderGroupAlternate(alternate);
        }, this));
    },
    renderGroupAlternate: function (alternate) {
        let category = alternate.get('category'),
            $outer = this.$('.bid-form-group-alternates'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.alternate-category[data-category="' + category + '"]>.alternates');
            if ($container.length === 0) {
                let subtotal = 0;
                _.each(_.filter(this.model.alternates.models, function (alternate) {
                    return alternate.get('category') === category
                }), function (alternate) {
                    subtotal += alternate.calculateTotal();
                });
                $outer.append('<div class="alternate-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="alternates ml-2"></div><div class="subtotal-outer ml-2 mb-2"></div></div>');

                let $category = $outer.find('.alternate-category[data-category="' + category + '"]');
                $container = $category.find('.alternates');

                let $subtotal = $category.find('.subtotal-outer');
                $subtotal.append('<div><div class="row border-top border-muted fs-16 pt-2"><div class="offset-7 col-2 text-align-right font-weight-medium">Subtotal:</div><div class="col-2 text-align-center subtotal no-padding-right subtotal">' + PJQ.helpers.formatHelpers.formatCurrency(subtotal) + '</div></div></div>');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: alternate,
            isEdit: this.options.isEdit,
            subTotal: PJQ.helpers.formatHelpers.formatCurrency(alternate.calculateTotal()),
            formatHelpers: PJQ.helpers.formatHelpers,
            getItemInput: _.bind(this.getItemInput, this),
            isError: this.options.isShowErrors && alternate.get('isRequired') && (alternate.get('cost') == null || (alternate.get('type').toLowerCase() !== "sum" && alternate.get('multiplier') == null)),
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments')
        };
        this.renderSubTemplate(true, this.options.subTemplates.alternate, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, alternate, _.bind(function (value) {
                this.updateBidFormItem(alternate, value);
            }, this));
        }, this));
    },
    groupAlternateChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-alternate-row'),
            cid = row.data('cid'),
            costDollars = row.find('.group-alternate-cost-dollars').val(),
            costCents = row.find('.group-alternate-cost-cents').val(),
            multiplier = row.find('.group-alternate-multiplier').val(),
            descriptionInput = row.find('.group-alternate-description'),
            typeInput = row.find('.group-alternate-type'),
            model = this.model.alternates.get({cid: cid});

        if (costDollars.length > 0 && costCents.length === 0) {
            costCents = '00';
        } else if (costDollars.length === 0 && costCents.length > 0) {
            costDollars = '0';
        }

        model.set({
            cost: costDollars.length === 0 && costCents.length === 0 ? null : PJQ.helpers.formatHelpers.getTotalCents(costDollars, costCents),
            multiplier: isNaN(multiplier) ? 0 : multiplier
        });

        this.calculateAlternateSubtotal(e);

        if (descriptionInput.length > 0 && typeInput.length > 0) {
            let type = typeInput.val();
            model.set('description', descriptionInput.val());
            if (model.get('type') !== type) {
                if (type.toLowerCase() === 'sum')
                    model.set('multiplier', 0);
                model.set('type', type);

                this.renderGroupAlternates();
            }
        }
    },
    deleteGroupAlternate: function (e) {
        let cid = $(e.currentTarget).closest('.group-alternate-row').data('cid');
        this.model.updateAlternateDeleted(cid, true);
        $(e.currentTarget).closest('.group-alternate-row').remove();
    },
    renderGroupAcknowledgement: function (acknowledgement) {
        let category = acknowledgement.get('category'),
            $outer = this.$('.bid-form-acknowledgements'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.acknowledgement-category[data-category="' + category + '"]>.acknowledgements');
            if ($container.length === 0) {
                $outer.append('<div class="acknowledgement-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="acknowledgements ml-2"></div></div>');

                let $category = $outer.find('.acknowledgement-category[data-category="' + category + '"]');
                $container = $category.find('.acknowledgements');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: acknowledgement ? acknowledgement : new PJQ.models.bidForms.Acknowledgement(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.groupAcknowledgement, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, acknowledgement, _.bind(function (value) {
                this.updateBidFormItem(acknowledgement, value);
            }, this));
        }, this));
    },
    renderProjectAcknowledgement: function (acknowledgement) {
        let category = acknowledgement.get('category'),
            $outer = this.$('.bid-form-acknowledgements'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.acknowledgement-category[data-category="' + category + '"]>.acknowledgements');
            if ($container.length === 0) {
                $outer.append('<div class="acknowledgement-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="acknowledgements ml-2"></div></div>');

                let $category = $outer.find('.acknowledgement-category[data-category="' + category + '"]');
                $container = $category.find('.acknowledgements');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: acknowledgement ? acknowledgement : new PJQ.models.bidForms.Acknowledgement(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.projectAcknowledgement, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, acknowledgement, _.bind(function (value) {
                this.updateBidFormItem(acknowledgement, value);
            }, this));
        }, this));
    },
    renderProjectBonding: function (bonding) {
        let data = {
            item: bonding ? bonding : new PJQ.models.bidForms.Bonding(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.bonding, this.$('.bid-form-bonding'), data, _.bind(function (content) {
            this.attachItemEvents(content, bonding, _.bind(function (value) {
                this.updateBidFormItem(bonding, value);
            }, this));
        }, this));
    },
    renderProjectCertification: function (certification) {
        let data = {
            item: certification ? certification : new PJQ.models.bidForms.Certification(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.certification, this.$('.bid-form-certifications'), data, _.bind(function (content) {
            this.attachItemEvents(content, certification, _.bind(function (value) {
                this.updateBidFormItem(certification, value);
            }, this));
        }, this));
    },
    renderProjectLaborRate: function (laborRate) {
        let data = {
            item: laborRate ? laborRate : new PJQ.models.bidForms.LaborRate(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.laborRate, this.$('.bid-form-labor-rates'), data, _.bind(function (content) {
            this.attachItemEvents(content, laborRate, _.bind(function (value) {
                this.updateBidFormItem(laborRate, value);
            }, this));
        }, this));
    },
    updateBidFormItem: function (model, value) {
        model.set({
            value: value,
            answer: value
        });
    },
    attachItemEvents: function (el, item, callback) {
        let type = item.get('type').toLowerCase(),
            isValid = !item.get('isRequired') ||
                (_.size(item.get('answer')) > 0 || _.size(item.get('cost')) > 0 || _.size(item.get('value')) > 0)
        if (type === 'yes/no' || type.indexOf('choice') !== -1) {
            isValid = _.size(item.get('value')) > 0 || _.size(item.get('answer')) > 0;
            let isMultiple = (type === 'multiple choice'),
                val = item.get('value') != null && _.size(item.get('value')) > 0 ? item.get('value') : item.get('answer');
            selPicker = new PJQ.inputs.Selectpicker({
                el: el.find('.bid-form-item-select'),
                noneSelectedText: 'Select Value',
                isMultiple: isMultiple,
                defaultValue: isMultiple && val != null ? val.split('|') : val,
                onChange: _.bind(function (value) {
                    if (isMultiple && PJQ.helpers.objectHelpers.refinedType(value) === 'array' && value.length > 0) {
                        value = value.join('|');
                    }
                    callback(value);
                }, this)
            });

            if (this.options.isShowErrors && !isValid) {
                selPicker.showError();
            }
        } else if (type === 'date' || type === 'date/time') {
            let date = item.get('answer') != null ? item.get('answer') : item.get('value') != null ? item.get('value') : null,
                isValid = _.size(date) > 0 || date != null;
            if (typeof date === 'object' && date != null) {
                date = type === 'date' ? date.toDateString() : date;
            }
            new PJQ.inputs.Datepicker({
                el: el.find('.bid-form-item-' + type.replace('/', '') + '>.datepicker'),
                datepickerOptions: {
                    format: type === 'date' ? PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE : undefined,
                    defaultDate: date
                },
                onChange: _.bind(function (value) {
                    callback(value);
                }, this)
            });

            if (this.options.isShowErrors && !isValid) {
                let input = el.find('.datepicker');
                PJQ.helpers.inputHelpers.setInputError(input, false);
            }
        } else if (type === 'money') {
            let $money = el.find('.bid-form-item-dollars,.bid-form-item-cents');
            $money.on('change', _.bind(function () {
                let dollarsText = el.find('.bid-form-item-dollars').val(),
                    centsText = el.find('.bid-form-item-cents').val();

                let dollars;
                if (dollarsText.length === 0) {
                    dollars = null;
                } else {
                    dollars = parseInt(dollarsText) * 100;
                }

                let cents;
                if (centsText.length === 0) {
                    cents = null;
                } else {
                    cents = parseInt(centsText);
                }

                let value;
                if (dollars == null && cents == null) {
                    value = null
                } else {
                    value = (dollars > 0 ? dollars : 0) + (cents > 0 ? cents : 0);
                }
                callback(value);
            }, this));
            if (this.options.isShowErrors && !isValid) {
                PJQ.helpers.inputHelpers.setInputError($money, false);
            }
        } else if (type === 'text' || type === 'numeric' || type === 'textarea') {
            el.find('.bid-form-item-input').on('change', function () {
                let value = $(this).val();
                callback(value);
            });
            if (this.options.isShowErrors && !isValid) {
                let input = el.find('.form-control');
                PJQ.helpers.inputHelpers.setInputError(input, false);
            }
        }

        // comments
        if (typeof item.attributes.comments != "undefined") {
            let buttonClass = (item instanceof PJQ.models.bidForms.ProposalLineItem) ? 'btn-line-item-comments' : 'btn-alternate-comments',
                parentIdField = (item instanceof PJQ.models.bidForms.ProposalLineItem) ? 'proposalLineItemId' : 'proposalAlternateId',
                commentIdField = (item instanceof PJQ.models.bidForms.ProposalLineItem) ? 'proposalLineItemCommentId' : 'proposalAlternateCommentId';
            if ((!(item.get(parentIdField) > 0) && !this.options.isEdit) || (item.comments.length == 0 && !PJQ.app.session.project.hasPermission('bidForms.canAddComments'))) {
                el.find('.' + buttonClass).attr('disabled', true);
            } else {
                el.find('.' + buttonClass).off('click').on('click', _.bind(function (event) {
                    new PJQ.views.bidForms.ProposalItemEditModal({
                        item: item,
                        onSave: _.bind(function () {
                            var comments = _.filter(item.comments.models, function (comment) {
                                    return !comment.get('isDeleted');
                                }),
                                $commentButton = el.find('.' + buttonClass),
                                $commentButtonIcon = el.find('.' + buttonClass + ' i'),
                                tooltip = 'No';

                            if (comments.length > 0) {
                                tooltip = comments.length.toString();

                                $commentButton.removeClass('btn-transparent-dark').addClass('btn-light');
                                $commentButtonIcon.removeClass('text-muted').addClass('text-dark');
                            } else {
                                $commentButton.removeClass('btn-light').addClass('btn-transparent-dark');
                                $commentButtonIcon.removeClass('text-dark').addClass('text-muted');
                            }

                            tooltip = tooltip + ' Comment' + (comments.length != 1 ? 's' : '');
                            $commentButton.attr('title', tooltip);

                            // if we're not in edit mode, we have to manually save changes to the comments.
                            if (!this.options.isEdit && _.some(item.comments.models, function (model) {
                                return !model.get(commentIdField) || model.get('isDeleted');
                            })) {
                                item.comments.save({
                                    success: _.bind(function (data) {
                                        item.comments.reset(data);
                                        PJQ.notifications.notify.successNotify({
                                            message: 'Comments updated successfully'
                                        });
                                    }, this),
                                    error: _.bind(function () {
                                        PJQ.notifications.notify.errorNotify({
                                            message: 'Comment update failed'
                                        });
                                    }, this)
                                });
                            }
                        }, this)
                    });
                }, this));
            }
        }
    },
    calculateLineItemSubtotal: function (e) {
        let row = $(e.currentTarget).closest('.group-line-item-row'),
            cid = row.data('cid'),
            lineItem = this.model.lineItems.get(cid);
        row.find('.group-line-item-total').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.calculateTotal()));
        this.calculateTotal();
    },
    calculateAlternateSubtotal: function (e) {
        let row = $(e.currentTarget).closest('.group-alternate-row'),
            cid = row.data('cid'),
            alternate = this.model.alternates.get(cid);
        row.find('.group-alternate-total').text(PJQ.helpers.formatHelpers.formatCurrency(alternate.calculateTotal()));
        this.calculateTotal();
    },
    calculateTotal: function () {
        let lineItemCategoryTotals = {};
        _.each(this.model.lineItems.models, function (item) {
            let category = item.get('category');
            if (_.size(category) === 0) {
                return;
            } else if (lineItemCategoryTotals[category] == null) {
                lineItemCategoryTotals[category] = 0;
            }
            lineItemCategoryTotals[category] += item.calculateTotal();
        });

        _.each(lineItemCategoryTotals, function (total, category) {
            let $subtotal = $('.line-item-category[data-category="' + category + '"] .subtotal');
            $subtotal.text(PJQ.helpers.formatHelpers.formatCurrency(total));
        });

        let alternateCategoryTotals = {};
        _.each(this.model.alternates.models, function (alternate) {
            let category = alternate.get('category');
            if (_.size(category) === 0) {
                return;
            } else if (alternateCategoryTotals[category] == null) {
                alternateCategoryTotals[category] = 0;
            }
            alternateCategoryTotals[category] += alternate.calculateTotal();
        });

        _.each(alternateCategoryTotals, function (total, category) {
            let $subtotal = $('.alternate-category[data-category="' + category + '"] .subtotal');
            $subtotal.text(PJQ.helpers.formatHelpers.formatCurrency(total));
        });

        this.$('.proposal-total').text(PJQ.helpers.formatHelpers.formatCurrency(this.model.calculateTotal(false, true)));
        this.$('.proposal-total-alt').text(PJQ.helpers.formatHelpers.formatCurrency(this.model.calculateTotal(true, true)));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    },
    numbersOnlyNegative: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, false, true);
    },
    numbersAndSingleDecimalOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersAndSingleDecimalOnly(e);
    },
    inclusionsChanged: function () {
        this.model.set('inclusions', this.$('.bid-form-inclusions').val());
    },
    exclusionsChanged: function () {
        this.model.set('exclusions', this.$('.bid-form-exclusions').val());
    },
    notesChanged: function () {
        this.model.set('notes', this.$('.bid-form-notes').val());
    },
    downloadAdditionalBidDocument: function (e) {
        let cid = $(e.currentTarget).closest('.bid-form-additional-document').data('cid'),
            attachment = this.options.settings.additionalBidDocuments.get({cid: cid});
        attachment.download();
    },
    downloadAttachment: function (e) {
        let cid = $(e.currentTarget).closest('.bid-form-attachment').data('cid'),
            attachment = this.model.attachments.get({cid: cid});
        attachment.download();
    },
    exportProposalWithAttachments: function () {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: _.bind(function (exportLeveledProposal, exportComments) {
                    this.exportZip(null, exportLeveledProposal, exportComments);
                }, this)
            });
        } else {
            this.exportZip();
        }
    },
    exportAttachments: function () {
        this.exportZip('attachments');
    },
    exportZip: function (mode, isExportLeveling, isExportComments) {
        let params;
        if (_.size(mode) > 0 || isExportLeveling || isExportComments) {
            params = [
                {
                    parameter: 'mode',
                    value: mode
                },
                {
                    parameter: 'leveling',
                    value: isExportLeveling
                },
                {
                    parameter: 'comments',
                    value: isExportComments
                }
            ];
        }
        PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.model.id
            },
            {
                endpoint: 'createexport'
            }
        ], params));
    },
    exportProposal: function () {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: _.bind(function (exportLeveledProposal, exportComments) {
                    this.model.export(exportLeveledProposal, exportComments);
                }, this)
            });
        } else {
            this.model.export(false, false);
        }
    },
    compare: function () {
        new PJQ.views.bidForms.ProposalsCompareModal({
            collection: this.collection.getProposals(this.model.get('bidFormId')),
            compareProposals: [this.model],
            settings: this.options.settings
        });
    },
    edit: function () {
        this.options.isEdit = true;
        this.render();
    },
    deleteProposal: function () {
        if (this.model instanceof PJQ.models.bidForms.Proposal) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this proposal?  This will delete all versions of the proposal.",
                onDelete: _.bind(function () {
                    this.model.destroy();
                    this.collection.trigger('change');
                    if (this.options.modal != null) {
                        this.options.modal.removeModal();
                    }
                }, this)
            });
        }
    },
    cancelEdit: function () {
        this.options.isEdit = false;
        this.model.fetch();
        this.render();
    },
    save: function () {
        if (this.saving) {
            return;
        }
        this.saving = true;

        this.model.set('isSubmitted', false);

        let parentModal = this.$el.closest('.modal-dialog'),
            loader = new PJQ.Loader(parentModal ? parentModal : this.$el);
        this.options.isEdit = false;
        this.model.save(null, {
            success: _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Proposal saved'
                });
                loader.remove();
                this.render();
                this.saving = false;
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: 'Proposal could not be saved'
                });
                loader.remove();
                this.saving = false;
            }, this)
        });
    },
    setLocked: function () {
        this.options.isEdit = false;
        this.model.setLocked();
        this.render();
    },
    reject: function () {
        new PJQ.views.bidForms.RejectModal({
            onConfirm: _.bind(function (note) {
                this.options.isEdit = false;
                this.model.reject(note);
                this.render();
            }, this)
        });
    },
    submit: function () {
        if (!this.options.isAdmin && !this.options.settings.get('isAllowLateBids') && PJQ.helpers.dateHelpers.getTimeStats(new Date(this.model.get('dueDate')), new Date()).totalMinutes < -1) {
            this.render();
            return;
        }

        if (this.saving) {
            return;
        }
        this.saving = true;

        let self = this,
            hasError = false;
        if (this.fileUploader && !this.options.isAdmin && this.options.settings.get('isRequireAttachment') && _.size(this.model.attachments) === 0) {
            this.options.hasFileError = true;
            hasError = true;
        } else {
            let deletedCount = 0
            _.each(this.model.attachments.models, function (model) {
                if (model.get('isDeleted')) {
                    deletedCount++
                }
            }, this)
            if (deletedCount === _.size(this.model.attachments) && !this.options.isAdmin && this.options.settings.get('isRequireAttachment')) {
                hasError = true;
                this.options.hasFileError = true;
            } else {
                this.options.hasFileError = false;
            }
        }

        hasError = hasError || null != _.find(_.union(this.model.lineItems.models, this.model.alternates.models), function (item) {
            let value = item.get('answer') != null ? item.get('answer') : item.get('cost'),
                type = item.get('type').toLowerCase(),
                isValid = true;
            if (item.get('isRequired')) {
                switch (type) {
                    case 'date':
                    case 'date/time':
                        if (typeof value === 'object' && value != null) {
                            value = value.toDateString();
                        }
                        isValid = value != null && _.size(value) > 0;
                        break;
                    default:
                        isValid = typeof value === 'number' ? _.size(value.toString()) !== 0 : value != null && _.size(value) > 0;
                }
            }

            return !isValid;
        }, this);

        hasError = hasError || null != _.find(_.union(this.model.acknowledgements.models, this.projectBidForm.acknowledgements.models, this.projectBidForm.bonding.models, this.projectBidForm.certifications.models, this.projectBidForm.laborRates.models), function (item) {
            let value = item.get('value'),
                type = item.get('type').toLowerCase(),
                isValid = true;
            if (item.get('isRequired')) {
                switch (type) {
                    case 'date':
                    case 'date/time':
                        if (typeof value === 'object' && value != null) {
                            value = value.toDateString();
                        }
                        isValid = value != null && _.size(value) > 0;
                        break;
                    default:
                        isValid = typeof value === 'number' ? _.size(value.toString()) !== 0 : value != null && _.size(value) > 0;
                }
            }
            return !isValid;
        }, this);

        if (hasError) {
            this.options.isShowErrors = true;
            this.options.isEdit = true;
            this.render();
            this.saving = false;
        } else {
            if (this.fileUploader) {
                this.fileUploader.clearError();
            }
            new PJQ.views.BaseModal({
                header: "Confirm Submission",
                body: "Are you sure you want to submit this bid?",
                isShowCancelButton: true,
                okButtonText: "Confirm",
                onOk: () => {
                    if (this.isSubmitting) {
                        return;
                    }
                    this.isSubmitting = true;

                    let loader = new PJQ.Loader(this.$el);
                    this.options.isEdit = false;
                    this.model.submit(true, () => {
                        this.render();
                        loader.remove();
                        this.saving = false;
                        this.isSubmitting = false;
                    });
                },
                onClose: () => {
                    this.saving = false;
                }
            });
        }
    },
    unaward: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Award",
            body: "Are you sure you want to unaward this bid?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.options.isEdit = false;
                this.model.award(false);
                this.render();
            }, this)
        });
    },
    award: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Award",
            body: "Are you sure you want to award this bid?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.options.isEdit = false;
                this.model.award(true);
                this.render();
            }, this)
        });
    }
});

PJQ.views.bidForms.BidFormViewerSelectorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Viewer-Selector'),
    },
    afterRender: function () {
        new PJQ.views.bidForms.BidFormViewerSelector({
            el: this.$('.bid-form-selector'),
            model: this.model
        });
    }
});

PJQ.views.bidForms.BidFormViewerSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Selector'),
    },
    events: {
        "click .bid-form-view-button": "viewBidForm"
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, "sync", this.render);
        PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
            this.options.settings = settings;
            this.model.fetch();
        }, this));
    },
    beforeRender: function () {
        if (this.model.isFetched && _.size(this.model) === 0) {
            new PJQ.views.groups.SelectGroupsModal({
                alert: "We don't have any trades saved for you.  Please select those that you plan to bid.",
                selectorOptions: {
                    groupUserId: PJQ.app.session.project.get('masterUserId')
                },
                onSave: _.bind(function (data) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id
                            },
                            {
                                endpoint: 'contacts',
                                value: PJQ.app.session.contact.id
                            },
                            {
                                endpoint: 'groups'
                            }
                        ]),
                        data: data.selected
                    }).put().done(_.bind(function () {
                        this.model.fetch();
                    }, this));
                }, this)
            });
        }

        this.renderData = {
            models: this.model.proposals.models
        };
    },
    afterRender: function () {
        this.renderBidForms();
    },
    renderBidForms: function () {
        _.each(this.model.proposals.models, function (model) {
            this.renderBidForm(model);
        }, this);
    },
    renderBidForm: function (model) {
        new PJQ.views.bidForms.BidFormViewer({
            el: this.$('#bid-form-accordion').find('div[data-groupid="' + model.get('group').groupId + '"]'),
            model: model,
            projectBidForm: model.projectProposal,
            settings: this.options.settings,
            isEdit: !model.get('isSubmitted')
        });
    },
    viewBidForm: function (e) {
        let target = $(e.currentTarget),
            proposal = this.model.proposals.get(target.data('cid'));

        if (target.hasClass('btn-primary')) {
            let self = this;
            this.$('.bid-form-view-button').each(function () {
                let thisProposal = self.model.proposals.models.get($(this).data('cid'));
                $(this).text(thisProposal.id > 0 ? "Continue" : "Start").removeClass('btn-secondary').addClass('btn-primary');
            });
            target.addClass('btn-secondary');
            target.removeClass('btn-primary');
            target.text("Close");
        } else {
            target.addClass('btn-primary');
            target.removeClass('btn-secondary');
            target.text(proposal.id > 0 ? "Continue" : "Start");
        }
    }
});

PJQ.views.bidForms.ProposalSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Selector'),
    },
    events: {
        "click .proposal-edit-button": "editProposal",
        "click .proposal-review-button": "viewProposal"
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, "sync", this.render);
        this.listenTo(this.model.proposals, 'update fetch sync', this.render);
        PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
            this.options.settings = settings;
            this.model.fetch();
        }, this));
    },
    beforeRender: function () {
        if (!this.options.noGroups && (this.model.isFetched && _.size(this.model.proposals.models) === 0)) {
            let fnSelector = _.bind(function (groups) {
                new PJQ.views.groups.SelectGroupsModal({
                    alert: "We don't have any trades saved for you.  Please select those that you plan to bid.",
                    selectorOptions: {
                        groups: groups != null ? groups.models : null,
                        groupUserId: PJQ.app.session.project.get('masterUserId')
                    },
                    onSave: _.bind(function (data) {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'projects',
                                    value: PJQ.app.session.project.id
                                },
                                {
                                    endpoint: 'contacts',
                                    value: PJQ.app.session.contact.id
                                },
                                {
                                    endpoint: 'groups'
                                }
                            ]),
                            data: data.selected
                        }).put().done(_.bind(function () {
                            this.model.fetch();
                        }, this));
                    }, this)
                });
            }, this);
            if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_RESTRICT_TO_EXISTING_GROUPS)) {
                PJQ.app.session.project.fetchGroups(_.bind(function (groups) {
                    if (_.size(groups.models) === 0) {
                        this.options.noGroups = true;
                        this.render();
                        return;
                    }
                    fnSelector(groups);
                }, this));
            } else {
                fnSelector();
            }
        }
    },
    renderData: function () {
        return {
            options: this.options,
            models: this.model.proposals.models,
            settings: this.options.settings
        };
    },
    viewProposal: function (e) {
        let cid = $(e.currentTarget).closest('.proposal-outer').data('cid'),
            proposal = this.model.proposals.get(cid);
        new PJQ.views.bidForms.BidFormPreviewModal({
            model: proposal,
            projectBidForm: proposal.projectProposal,
            settings: this.options.settings
        });
    },
    editProposal: function (e) {
        let cid = $(e.currentTarget).closest('.proposal-outer').data('cid'),
            proposal = this.model.proposals.get(cid);
        new PJQ.views.bidForms.BidFormPreviewModal({
            model: proposal,
            projectBidForm: proposal.projectProposal,
            settings: this.options.settings,
            isEdit: true
        });
    }
});

PJQ.views.bidForms.ProposalItemEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Proposal-Item-Edit'),
        subTemplates: {
            comments: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Line-Item-Comments')
        },
        minWidth: '400px',
        onSave: _.noop,
        item: null
    },
    events: {
        'keyup .comment': 'commentChanged',
        'click .comment-add': 'commentAdded',
        'click .comment-delete': 'commentDeleted',
        'click .save-details': 'saveDetails'
    },
    beforeModalCreated: function () {
        if (this.options.item instanceof PJQ.models.bidForms.ProposalLineItem) {
            this.options.parentIdField = 'proposalLineItemId';
            this.options.commentIdField = 'proposalLineItemCommentId';
            this.options.CommentModel = PJQ.models.bidForms.ProposalLineItemComment;
        } else if (this.options.item instanceof PJQ.models.bidForms.Alternate) {
            this.options.parentIdField = 'proposalAlternateId';
            this.options.commentIdField = 'proposalAlternateCommentId';
            this.options.CommentModel = PJQ.models.bidForms.ProposalAlternateComment;
        }
    },
    beforeRender: function () {
        this.renderData = {
            item: this.options.item,
            comments: this.options.item.comments,
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments'),
            canAddComments: PJQ.app.session.project.hasPermission('bidForms.canAddComments'),
            commentIdField: this.options.commentIdField
        };
    },
    afterRender: function () {
        this.$('.comment-add').prop('disabled', true);

        if (PJQ.app.session.project.hasPermission('bidForms.canViewComments'))
            this.renderComments();

        this.$('.comment').focus();
    },
    renderComments: function () {
        let comments = _.filter(this.options.item.comments.models, function (comment) {
            return !comment.get('isDeleted');
        });
        if (_.size(comments) == 0) {
            this.$('.comments-header, .comments-list').addClass('hidden');
        } else {
            this.$('.comments-list').html('');
            this.$('.comments-header, .comments-list').removeClass('hidden');
            this.renderSubTemplate(true, this.options.subTemplates.comments, this.$('.comments-list'), {
                comments: this.options.item.comments,
                canDeleteComments: PJQ.app.session.project.hasPermission('bidForms.canDeleteComments'),
                commentIdField: this.options.commentIdField
            }, _.bind(function ($el) {
                // todo: bind delete button
                /*
                $el.find('.comment-delete').off('click').on('click', _.bind(function(event) {
                    console.log($(event.currentTarget).data('commentCid'));
                }, this));

                 */
            }, this));
        }
    },
    saveDetails: function () {
        if (typeof this.options.onSave == 'function')
            this.options.onSave();

        this.removeModal();
    },
    commentAdded: function () {
        let comment = new this.options.CommentModel();
        comment.set('proposalId', this.options.item.get('proposalId'));
        comment.set(this.options.parentIdField, this.options.item.get(this.options.parentIdField));
        comment.set('comment', this.$('.comment').val());
        comment.set('createdBy', PJQ.app.session.contact != null ? PJQ.app.session.contact.id : -PJQ.app.session.user.id);
        comment.set('createdByDisplay', PJQ.app.session.contact != null ? PJQ.app.session.contact.get('companyName') : PJQ.app.session.user.get('contactName'));
        comment.set('createdOn', new Date().toISOString());

        this.options.item.comments.add(comment);
        this.$('.comment').val('');
        this.$('.comment-add').prop('disabled', true);
        this.renderComments();
    },
    commentDeleted: function (sender) {
        this.selectedCard = this.$(sender.currentTarget).closest('div.card');

        new PJQ.views.BaseModal({
            header: "Delete Comment",
            body: "Are you sure you want to delete this comment?",
            isShowCancelButton: true,
            onOk: _.bind(function () {
                let commentCid = this.selectedCard.data('commentCid'),
                    comment = this.options.item.comments.get({cid: commentCid});

                if (comment.get(this.options.commentIdField) > 0)
                    comment.set('isDeleted', true);
                else
                    comment.destroy();

                this.renderComments();

            }, this)
        });

    },
    commentChanged: function () {
        this.$('.comment-add').prop('disabled', _.size(this.$('.comment').val()) === 0);
    }
});
